import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { inventoryFlowSchemas } from '../../flows/inventoryFlows';
import { receptionFlowSchemas } from '../../flows/receptionFlows';
import { putawayFlowSchemas } from '../../flows/putawayFlows';
import { pickingFlowSchemas } from '../../flows/pickingFlows';
import { getWmsOrdenByIdDocumento } from '../../api.wms';
import { puedeAgregarProductoEnUbicacion } from '../../utils/wmsUbicaciones';
import { getWmsProductoByBarcode } from '../../api.wms.productos';
import { getWmsAlmacenById } from '../../api.wms';
import { getWmsClientes } from '../../api.wms.clientes';
import { ingresarWmsInventario, updateWmsOrdenEstatus } from '../../api.wms';
import { getWmsProductos } from '../../api.wms.productos';
import { getWmsUbicaciones } from '../../api.wms';
import { getWmsProductoBySku } from '../../api.wms.productos';
import { getWmsUbicacionByCodigo } from '../../api.wms';
import { consultarInventario } from '../../api.wms.inventario';
import { registrarMovimientoInventario } from '../../api.wms.inventario';
import { consultarInventarioAgrupadoConIds } from '../../api.wms.inventario';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

const stepIcons = {
  scan: <span className="pi pi-barcode text-blue-500 text-2xl mr-2" />,
  input: <span className="pi pi-pencil text-green-500 text-2xl mr-2" />,
  confirm: <span className="pi pi-check-circle text-cyan-500 text-2xl mr-2" />,
  'scan-multiple-sku': <span className="pi pi-barcode text-green-600 text-2xl mr-2" />
};

function FlowRunner(props) {
  // TODOS los hooks aquí, ANTES de cualquier return condicional
  // (useState, useEffect, useRef, etc.)
  const { flowKey } = useParams();
  const esRecepcionPedidos = flowKey === 'recepcion-pedidos';
  const navigate = useNavigate();
  const inventorySchemas = inventoryFlowSchemas || {};
  const receptionSchemas = receptionFlowSchemas || {};
  const putawaySchemas = putawayFlowSchemas || {};
  const pickingSchemas = pickingFlowSchemas || {};
  const allSchemas = { ...inventorySchemas, ...receptionSchemas, ...putawaySchemas, ...pickingSchemas };
  // Permitir recibir el flujo por props (para putaway y otros)
  const flow = props.flow || allSchemas[flowKey];

  // Estados principales
  const [stepIndex, setStepIndex] = useState(0);
  const [formData, setFormData] = useState({ productos: [] });
  const [error, setError] = useState('');
  const [productosEscaneados, setProductosEscaneados] = useState([]);
  const [descripcionSku, setDescripcionSku] = useState({});
  const [loteStep, setLoteStep] = useState({ active: false, skuIndex: 0, unidadIndex: 0, mismoLote: true });
  const [lotesPorSku, setLotesPorSku] = useState({});
  const [inputLoteData, setInputLoteData] = useState({ lote: '', estadoCalidad: 'A', ubicacion: '', errorLote: '' });
  const [colocacionStep, setColocacionStep] = useState({ activo: false, index: 0 });
  const [ubicacionesAsignadas, setUbicacionesAsignadas] = useState([]);
  const [ubicacionInput, setUbicacionInput] = useState('');
  const [errorUbicacion, setErrorUbicacion] = useState('');
  const [ordenEntrada, setOrdenEntrada] = useState(null);
  const [ordenError, setOrdenError] = useState('');
  const [ordenLoading, setOrdenLoading] = useState(false);
  const [nombresCargados, setNombresCargados] = useState(false);
  const [nombreCliente, setNombreCliente] = useState('');
  const [nombreAlmacen, setNombreAlmacen] = useState('');
  const [errorScan, setErrorScan] = useState('');
  const [modoIngreso, setModoIngreso] = useState(null);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [intentosCantidad, setIntentosCantidad] = useState(0);
  const [mostrarErrorCantidad, setMostrarErrorCantidad] = useState(false);
  const [tipoDiferencia, setTipoDiferencia] = useState(null);
  const [cantidadEsperada, setCantidadEsperada] = useState(null);
  const [productosRecibidos, setProductosRecibidos] = useState([]);
  const [mostrarPreguntaMasProductos, setMostrarPreguntaMasProductos] = useState(false);
  const [stagingArea, setStagingArea] = useState('');
  const [mostrarStaging, setMostrarStaging] = useState(false);
  const [finalizado, setFinalizado] = useState(false);
  const [procesandoFinal, setProcesandoFinal] = useState(false);
  const [errorFinal, setErrorFinal] = useState('');
  const [exitoFinal, setExitoFinal] = useState(false);
  const [consultaInventarioResultados, setConsultaInventarioResultados] = useState([]);
  const [consultaInventarioLoading, setConsultaInventarioLoading] = useState(false);
  const [consultaInventarioError, setConsultaInventarioError] = useState('');
  const [tipoBusquedaInventario, setTipoBusquedaInventario] = useState('');
  const [scanOrderInput, setScanOrderInput] = useState('');
  const scanOrderInputRef = React.useRef(null);
  // Ref global para input de escaneo de SKU
  const scanSkuInputRef = React.useRef(null);
  // Ref global para input de escaneo de área de staging
  const scanStagingInputRef = React.useRef(null);
  // Hooks para escaneo múltiple y selección de línea (deben estar fuera de condicionales)
  const [modalSeleccion, setModalSeleccion] = React.useState(null);
  const [scanInput, setScanInput] = React.useState('');
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [confirmacionVisual, setConfirmacionVisual] = useState(null); // 'exito' | 'error' | null
  const [confirmacionLote, setConfirmacionLote] = useState(null); // 'exito' | 'error' | null
  const [modoVerificacion, setModoVerificacion] = useState(null);
  const [estadoConfirmacion, setEstadoConfirmacion] = useState(null); // 'exito' | 'error' | null
  const [inputUbicacion, setInputUbicacion] = useState('');
  const [errorAjuste, setErrorAjuste] = useState('');
  const [loadingAjuste, setLoadingAjuste] = useState(false);
  const [catalogoProductos, setCatalogoProductos] = useState([]);
  const inputRef = React.useRef(null);
  // Drawer de productos esperados (debe estar fuera de condicionales)
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  // Drag drawer logic (debe estar fuera de condicionales)
  const drawerRef = React.useRef();
  const startY = React.useRef(0);
  const lastY = React.useRef(0);
  const dragging = React.useRef(false);
  const [ordenCerrada, setOrdenCerrada] = useState(false);
  // Ref para input oculto de consulta de inventario
  const inputConsultaRef = React.useRef(null);
  const [reimpresionExito, setReimpresionExito] = React.useState(false);
  // Nuevo estado para inventario de staging
  const [inventarioStaging, setInventarioStaging] = useState([]);
  const [loadingInventarioStaging, setLoadingInventarioStaging] = useState(false);
  const [errorInventarioStaging, setErrorInventarioStaging] = useState('');
  // Estados para generación de HU y movimientos en paletizado
  const [loadingGenerar, setLoadingGenerar] = useState(false);
  const [errorGenerar, setErrorGenerar] = useState('');
  // --- ESTADOS PARA PICKING DIRIGIDO ---
  const [pickingIndex, setPickingIndex] = useState(0); // índice del producto actual a pickear
  const [productosPicking, setProductosPicking] = useState([]); // productos pendientes de la orden
  const [ubicacionSugerida, setUbicacionSugerida] = useState(null); // ubicación sugerida para el producto
  const [cantidadPickeada, setCantidadPickeada] = useState('');
  const [ubicacionEscaneada, setUbicacionEscaneada] = useState('');
  const [pickingConfirmado, setPickingConfirmado] = useState(false);
  const [resumenPicking, setResumenPicking] = useState([]);
  const [pickingActivo, setPickingActivo] = useState(false);
  const [alternativas, setAlternativas] = useState([]); // Alternativas de picking (otros lotes)
  const [mostrarAlternativas, setMostrarAlternativas] = useState(false); // Mostrar tabla de alternativas
  const [pickingReady, setPickingReady] = useState(false);
  // Wrappers para debug de setters
  const setPickingActivoDebug = (valor) => { console.log('setPickingActivo', valor); setPickingActivo(valor); };
  const setPickingReadyDebug = (valor) => { console.log('setPickingReady', valor); setPickingReady(valor); };
  const setProductosPickingDebug = (valor) => { console.log('setProductosPicking', valor); setProductosPicking(valor); };
  const setPickingIndexDebug = (valor) => { console.log('setPickingIndex', valor); setPickingIndex(valor); };
  // Estados para validación de ubicación y errores de picking dirigido
  const [ubicacionValidaOk, setUbicacionValidaOk] = useState(false);
  const [errorPicking, setErrorPicking] = useState('');
  // --- Estados para wizard de picking dirigido ---
  const [wizardStep, setWizardStep] = useState(1); // 1: info, 2: ubicacion, 3: cantidad, 4: staging
  const [ubicacionStaging, setUbicacionStaging] = useState('');
  const inputStagingRef = React.useRef(null);
  const inputUbicacionRef = React.useRef(null);
  // --- Estados para feedback visual tras finalizar picking ---
  const [estadoFinalPicking, setEstadoFinalPicking] = useState(null); // 'exito' | 'error' | null
  const [mensajeFinalPicking, setMensajeFinalPicking] = useState('');

  // --- Función para finalizar picking ---
  const finalizarPicking = async (ubicacionStagingCodigo, resumenPicking) => {
    console.log('=== FINALIZAR PICKING ===');
    console.log('Ubicación staging:', ubicacionStagingCodigo);
    console.log('Resumen picking:', resumenPicking);
    console.log('Orden entrada:', ordenEntrada);
    
    setProcesandoFinal(true);
    setEstadoFinalPicking(null);
    setMensajeFinalPicking('');
    
    try {
      // Validar que hay productos pickeados
      let productosPickeados = resumenPicking.filter(item => !item.omitido && item.cantidad_pick && item.cantidad_pick > 0);
      // Asignar el sku correcto si falta
      productosPickeados = productosPickeados.map(item => {
        if (!item.sku) {
          // Buscar en el catálogo de productos
          const prodCat = catalogoProductos.find(p => String(p.id) === String(item.producto_id));
          return { ...item, sku: prodCat ? prodCat.codigo_producto : undefined };
        }
        return item;
      });
      console.log('Productos pickeados:', productosPickeados);
      
      if (productosPickeados.length === 0) {
        throw new Error('No hay productos pickeados para mover al inventario');
      }
      
      // 1. Obtener el objeto de la ubicación de staging (destino)
      const ubicStaging = await getWmsUbicacionByCodigo(ubicacionStagingCodigo);
      if (!ubicStaging || !ubicStaging.id) throw new Error('No se encontró el área de staging');
      const destino_id = ubicStaging.id;
      console.log('Destino ID:', destino_id);

      // 2. Preparar movimientos para cada producto pickeado
      const movimientos = [];
      for (const item of productosPickeados) {
        console.log('Procesando item:', item);
        // Buscar el inventario origen para este producto/lote/calidad en la ubicación origen
        const inventarioOrigen = await consultarInventarioAgrupadoConIds({
          sku: item.sku,
          ubicacion: item.ubicacion_pick, // este es el código de la ubicación origen
          cliente_id: ordenEntrada?.cliente_id || undefined
        });
        console.log('Inventario origen encontrado:', inventarioOrigen);
        // Buscar el match exacto
        const invMatch = (inventarioOrigen || []).find(inv =>
          String(inv.sku) === String(item.sku) &&
          String(inv.lote || '') === String(item.lote || '') &&
          String(inv.estado_calidad || '') === String(item.calidad || '')
        );
        if (!invMatch) throw new Error(`No se encontró inventario origen para SKU ${item.sku} en ubicación ${item.ubicacion_pick}`);
        console.log('Match encontrado:', invMatch);
        movimientos.push({
          inventory_id: invMatch.ids && invMatch.ids.length > 0 ? invMatch.ids[0] : undefined,
          producto_id: item.producto_id,
          cantidad: item.cantidad_pick,
          origen_id: invMatch.ubicacion_id,
          destino_id,
          lote: item.lote || null,
          estado_calidad: item.calidad || null,
          tipo: 'picking',
          usuario_id: null,
          referencia: ordenEntrada?.iddocumento || null,
          observaciones: `Picking dirigido - ${item.sku || item.descripcion}`,
          cliente_id: ordenEntrada?.cliente_id || null,
          fecha: new Date().toISOString()
        });
      }
      console.log('Movimientos a enviar:', movimientos);
      if (movimientos.length === 0) throw new Error('No hay productos pickeados para mover');
      // 3. Registrar movimientos de inventario
      console.log('Llamando a registrarMovimientoInventario...');
      await registrarMovimientoInventario(movimientos);
      console.log('Movimientos registrados exitosamente');
      // 4. Cerrar la orden
      if (ordenEntrada?.id) {
        console.log('Cerrando orden:', ordenEntrada.id);
        await updateWmsOrdenEstatus(ordenEntrada.id, 'cerrada');
        console.log('Orden cerrada exitosamente');
      }
      setEstadoFinalPicking('exito');
      setMensajeFinalPicking('Picking finalizado correctamente');
    } catch (err) {
      console.error('Error en finalizarPicking:', err);
      setEstadoFinalPicking('error');
      setMensajeFinalPicking('Error al finalizar el picking: ' + (err?.message || ''));
    } finally {
      setProcesandoFinal(false);
    }
  };

 
// Declarar step y totalSteps INMEDIATAMENTE después de los hooks
let step = null;
let totalSteps = 0;
if (flow) {
  if (flowKey === 'verificacion-ubicacion' && stepIndex >= 2) {
    step = flow.steps[stepIndex - 1];
    totalSteps = flow.steps.length + 1;
  } else {
    step = flow.steps[stepIndex];
    totalSteps = flow.steps.length;
  }
}

  // Drag con mouse/touch
  const onMove = (clientY) => {
    if (!dragging.current) return;
    const delta = clientY - startY.current;
    if (drawerRef.current) {
      drawerRef.current.style.transform = `translateY(${Math.max(0, delta)}px)`;
      lastY.current = delta;
    }
  };
  const onEnd = () => {
    dragging.current = false;
    if (lastY.current > 80) {
      setDrawerOpen(false);
    } else if (drawerRef.current) {
      drawerRef.current.style.transform = '';
    }
    window.removeEventListener('mousemove', mouseMove);
    window.removeEventListener('mouseup', mouseUp);
    window.removeEventListener('touchmove', touchMove);
    window.removeEventListener('touchend', touchEnd);
  };
  const mouseMove = (e) => onMove(e.clientY);
  const mouseUp = () => onEnd();
  const touchMove = (e) => onMove(e.touches[0].clientY);
  const touchEnd = () => onEnd();
  function startDragDrawer(e) {
    dragging.current = true;
    startY.current = (e.touches ? e.touches[0].clientY : e.clientY);
    lastY.current = 0;
    window.addEventListener('mousemove', mouseMove);
    window.addEventListener('mouseup', mouseUp);
    window.addEventListener('touchmove', touchMove);
    window.addEventListener('touchend', touchEnd);
  }

  // useEffect para nombres de cliente y almacén
  useEffect(() => {
    if (ordenEntrada && !nombresCargados) {
      // Buscar nombre de cliente y almacén
      (async () => {
        let clienteNombre = '';
        let almacenNombre = '';
        try {
          if (ordenEntrada.cliente_id) {
            const clientes = await getWmsClientes();
            const cliente = clientes.find(c => String(c.id) === String(ordenEntrada.cliente_id));
            clienteNombre = cliente ? cliente.nombre : '';
          }
          if (ordenEntrada.almacen_id) {
            const almacen = await getWmsAlmacenById(ordenEntrada.almacen_id);
            almacenNombre = almacen ? almacen.nombre : '';
          }
        } catch {}
        setNombreCliente(clienteNombre);
        setNombreAlmacen(almacenNombre);
        setNombresCargados(true);
      })();
    } else if (!ordenEntrada && nombresCargados) {
      setNombresCargados(false);
      setNombreCliente('');
      setNombreAlmacen('');
    }
  }, [ordenEntrada, nombresCargados]);

  // useEffect para ejecutar lógica de inventario y cierre de orden al finalizar
  useEffect(() => {
    const ejecutarFinalizacion = async () => {
      if (
        esRecepcionPedidos && finalizado && productosRecibidos.length > 0 && ordenEntrada && stagingArea && !exitoFinal && !procesandoFinal
      ) {
        setProcesandoFinal(true);
        setErrorFinal('');
        try {
          const ubicStaging = await getWmsUbicacionByCodigo(stagingArea);
          if (!ubicStaging) throw new Error('No se encontró el área de staging en ubicaciones.');
          // Agrupar productos recibidos por combinación única de producto_id, lote, serie, caducidad, calidad
          const agrupados = {};
          for (const p of productosRecibidos) {
            // Obtener producto_id real
            let prod = null;
            try {
              if (p.sku && /^\d{8,}$/.test(p.sku)) {
                prod = await getWmsProductoBySku(p.sku);
              } else if (p.sku) {
                prod = await getWmsProductoBySku(p.sku);
              } else if (p.codigo_producto) {
                prod = await getWmsProductoBySku(p.codigo_producto);
              }
            } catch {}
            if (!prod && p.producto_id) {
              prod = { id: p.producto_id };
            }
            if (!prod) throw new Error(`No se encontró el producto con SKU, código de barras o ID: ${p.sku || p.codigo_producto || p.producto_id}`);
            // Clave única por producto/lote/serie/caducidad/calidad
            const key = [prod.id, p.lote || '', p.serie || '', p.caducidad || '', p.calidad || p.estado_calidad || 'A'].join('|');
            if (!agrupados[key]) {
              agrupados[key] = {
                producto_id: prod.id,
                lote: p.lote || '',
                estado_calidad: p.calidad || p.estado_calidad || 'A',
                fecha_caducidad: p.caducidad || null,
                numero_serie: p.serie || null,
                cantidad: 0,
                cliente_id: ordenEntrada.cliente_id,
                ubicacion_id: ubicStaging.id,
                fecha_ingreso: new Date().toISOString(),
                tipo: 'ajuste',
                hu_id: null,
                observaciones: null
              };
            }
            agrupados[key].cantidad += Number(p.cantidad) || 1;
          }
          const movimientos = Object.values(agrupados);
          await ingresarWmsInventario(movimientos);
          await updateWmsOrdenEstatus(ordenEntrada.id, 'cerrada');
          setExitoFinal(true);
        } catch (err) {
          setErrorFinal('Error al afectar inventario o cerrar la orden. ' + (err?.message || 'Intenta de nuevo o contacta a soporte.'));
        } finally {
          setProcesandoFinal(false);
        }
      }
    };
    ejecutarFinalizacion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalizado]);

  // useEffect para consulta de inventario en el flujo 'consulta'
  useEffect(() => {
    async function buscarInventarioRobusto() {
      setConsultaInventarioResultados([]);
      setConsultaInventarioError('');
      setConsultaInventarioLoading(false);
      setTipoBusquedaInventario('');
      if (flowKey === 'consulta' && formData.criterio && flow && flow.steps && flow.steps[stepIndex] && flow.steps[stepIndex].type === 'confirm') {
        setConsultaInventarioLoading(true);
        const criterio = formData.criterio.trim();
        let resultados = [];
        try {
          let data = await consultarInventario({ sku: criterio });
          if (Array.isArray(data) && data.length > 0) {
            setConsultaInventarioResultados(data);
            setTipoBusquedaInventario('sku');
          } else {
            data = await consultarInventario({ ubicacion: criterio });
            if (Array.isArray(data) && data.length > 0) {
              setConsultaInventarioResultados(data);
              setTipoBusquedaInventario('ubicacion');
            } else {
              data = await consultarInventario({ codigo_barras: criterio });
              if (Array.isArray(data) && data.length > 0) {
                setConsultaInventarioResultados(data);
                setTipoBusquedaInventario('codigo_barras');
              } else {
                setConsultaInventarioResultados([]);
                setTipoBusquedaInventario('');
              }
            }
          }
        } catch (err) {
          setConsultaInventarioError('Error al consultar inventario.');
        } finally {
          setConsultaInventarioLoading(false);
        }
      }
    }
    buscarInventarioRobusto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowKey, formData.criterio, stepIndex]);

  // useEffect para forzar el foco en el input invisible
  useEffect(() => {
    if (scanOrderInputRef.current && flowKey === 'recepcion-pedidos' && stepIndex === 0) {
      scanOrderInputRef.current.focus();
    }
  }, [stepIndex, flowKey, ordenError]);

  // Debounce para validar la orden escaneada
  useEffect(() => {
    if (flowKey !== 'recepcion-pedidos' || stepIndex !== 0) return;
    if (!scanOrderInput) return;
    const timeout = setTimeout(async () => {
      setLoadingOrder(true);
      setOrdenError('');
      setOrdenEntrada(null);
      try {
        const data = await getWmsOrdenByIdDocumento(scanOrderInput.trim().replace(/'/g, '-'));
        if (data) {
          if (data.estado === 'cerrada') {
            setOrdenCerrada(true);
            setOrdenError('La orden ya fue trabajada o está cerrada.');
            setScanOrderInput('');
            setLoadingOrder(false);
            return;
          }
          setOrdenEntrada(data);
          setScanOrderInput('');
          setError('');
          setStepIndex(stepIndex + 1);
        } else {
          setOrdenError('No se encontró la orden de entrada con ese ID.');
          setScanOrderInput('');
        }
      } catch {
        setOrdenError('Error al buscar la orden.');
        setScanOrderInput('');
      } finally {
        setLoadingOrder(false);
      }
    }, 200);
    return () => clearTimeout(timeout);
  }, [scanOrderInput, flowKey, stepIndex]);

  // useEffect para enfocar input de escaneo de SKU solo si el paso es 'scan'
  useEffect(() => {
    if (step && step.type === 'scan' && scanSkuInputRef.current) {
      scanSkuInputRef.current.focus();
    }
  }, [stepIndex, step]);

  // useEffect para enfocar input de escaneo de ubicación en confirmación de ajuste
  useEffect(() => {
    if (inputRef && inputRef.current && step && step.type === 'confirm' && flowKey === 'verificacion-ubicacion' && !estadoConfirmacion) {
      inputRef.current.focus();
    }
  }, [step, flowKey, estadoConfirmacion]);

  // useEffect para enfocar input de escaneo de área de staging
  useEffect(() => {
    if (
      step &&
      step.type === 'scan' &&
      step.field === 'stagingArea' &&
      scanStagingInputRef.current
    ) {
      scanStagingInputRef.current.focus();
    }
  }, [step]);

  // Catálogo de productos global
  
  useEffect(() => {
    getWmsProductos().then(setCatalogoProductos);
  }, []);

  // --- EFECTO: Al escanear la orden, inicializar productos de picking ---
  // (ELIMINADO: este efecto causaba reseteos inesperados)
  // useEffect(() => {
  //   if (flowKey === 'picking' && ordenEntrada && Array.isArray(ordenEntrada.productos)) {
  //     setProductosPicking(ordenEntrada.productos.map(p => ({ ...p, pickeado: false, cantidad_pick: 0, ubicacion_pick: '' })));
  //     setPickingIndex(0);
  //     setResumenPicking([]);
  //     setUbicacionSugerida(null);
  //     setCantidadPickeada('');
  //     setUbicacionEscaneada('');
  //     setPickingConfirmado(false);
  //   }
  //   // eslint-disable-next-line
  // }, [ordenEntrada, flowKey]);



  // --- EFECTO: Desactivar pickingActivo si el flowKey cambia fuera de picking ---
  useEffect(() => {
    if (flowKey !== 'picking') {
      setPickingActivo(false);
      setPickingReady(false);
    }
  }, [flowKey]);

  // --- EFECTO: Buscar ubicación sugerida para el producto actual ---
  useEffect(() => {
    async function sugerirUbicacion() {
      if (flowKey === 'picking' && productosPicking.length > 0 && pickingIndex < productosPicking.length) {
        const prod = productosPicking[pickingIndex];
        try {
          const inventario = await consultarInventario({ sku: undefined, producto_id: prod.producto_id });
          // Filtrar ubicaciones de almacenamiento real y que coincidan lote, serie, caducidad, calidad si aplica
          const ubic = (inventario || []).filter(i =>
            i.producto_id === prod.producto_id &&
            (!prod.lote || String(i.lote || '').toUpperCase() === String(prod.lote).toUpperCase()) &&
            (!prod.serie || String(i.serie || '').toUpperCase() === String(prod.serie).toUpperCase()) &&
            (!prod.caducidad || String(i.caducidad || '').toUpperCase() === String(prod.caducidad).toUpperCase()) &&
            (!prod.calidad || String(i.estado_calidad || '').toUpperCase() === String(prod.calidad).toUpperCase()) &&
            i.ubicacion &&
            !['STAGE', 'STAGING', 'LOST'].some(prefix => String(i.ubicacion).toUpperCase().startsWith(prefix))
          )
          // Sugerir la ubicación con mayor cantidad disponible
          .sort((a, b) => (b.cantidad || 0) - (a.cantidad || 0))[0];
          setUbicacionSugerida(ubic || null);
        } catch {
          setUbicacionSugerida(null);
        }
      }
    }
    sugerirUbicacion();
    // eslint-disable-next-line
  }, [pickingIndex, productosPicking, flowKey]);


  // --- EFECTO: Buscar alternativas de picking cuando no hay ubicación sugerida ---
  useEffect(() => {
    if (
      flowKey === 'picking' &&
      pickingActivo &&
      productosPicking.length > 0 &&
      pickingIndex < productosPicking.length &&
      !ubicacionSugerida
    ) {
      const prod = productosPicking[pickingIndex];
      if (prod && prod.producto_id) {
        (async () => {
          try {
            const inventario = await consultarInventario({ sku: undefined, producto_id: prod.producto_id });
            const alternativasValidas = (inventario || []).filter(i =>
              i.producto_id === prod.producto_id &&
              (!prod.lote || String(i.lote || '').toUpperCase() === String(prod.lote).toUpperCase()) &&
              (!prod.serie || String(i.serie || '').toUpperCase() === String(prod.serie).toUpperCase()) &&
              (!prod.caducidad || String(i.caducidad || '').toUpperCase() === String(prod.caducidad).toUpperCase()) &&
              (!prod.calidad || String(i.estado_calidad || '').toUpperCase() === String(prod.calidad).toUpperCase()) &&
              i.ubicacion &&
              !['STAGE', 'STAGING', 'LOST'].some(prefix => String(i.ubicacion).toUpperCase().startsWith(prefix))
            );
            setAlternativas(alternativasValidas);
          } catch {
            setAlternativas([]);
          }
        })();
      }
    } else {
      setAlternativas([]);
    }
    // eslint-disable-next-line
  }, [flowKey, pickingActivo, productosPicking, pickingIndex, ubicacionSugerida]);

  // Pantalla de error si la orden está cerrada (debe ir antes de cualquier return condicional)
  if (ordenCerrada) {
    setTimeout(() => {
      setOrdenCerrada(false);
      navigate(-1);
    }, 1400);
    return (
      <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-500 z-50 animate-fade-in">
        <span className="text-white text-8xl mb-4">✖</span>
        <div className="text-white text-2xl font-bold mb-4">La orden ya fue trabajada o está cerrada</div>
      </div>
    );
  }

  // --- PRIORIDAD: Picking dirigido ---
  if (
    flowKey === 'picking' &&
    pickingActivo &&
    pickingReady &&
    productosPicking &&
    productosPicking.length > 0 &&
    pickingIndex < productosPicking.length
  ) {
    console.log('Render picking dirigido', { pickingActivo, pickingReady, productosPicking, pickingIndex });
    const prod = productosPicking[pickingIndex];
    const prodCat = catalogoProductos.find(p => String(p.id) === String(prod.producto_id));
    const ubicacionValida = ubicacionSugerida;

    if (!ubicacionValida && (!alternativas || alternativas.length === 0)) {
      console.log('Return: No hay inventario para el producto actual');
      return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column'}}>
          <h2>No hay inventario disponible para el producto actual</h2>
          <p>SKU: <b>{prodCat?.codigo_producto || prod.producto_id}</b></p>
          <button onClick={() => {
            setResumenPicking([...resumenPicking, { ...prod, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true }]);
            setProductosPicking(arr => arr.map((p, idx) => idx === pickingIndex ? { ...p, pickeado: true, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true } : p));
            setPickingIndex(pickingIndex + 1);
            setCantidadPickeada('');
            setUbicacionEscaneada('');
            setPickingConfirmado(false);
          }}>Omitir producto y continuar</button>
          <button
            onClick={() => setMostrarAlternativas(true)}
            disabled={alternativas.length === 0}
          >Ver alternativas de otros lotes</button>
        </div>
      );
    }

    if (mostrarAlternativas && alternativas.length > 0) {
      console.log('Return: Alternativas de picking');
      return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column'}}>
          <h2>Alternativas de lote/ubicación para {prodCat?.codigo_producto || prod.producto_id}</h2>
          <table>
            <thead>
              <tr>
                <th>Ubicación</th>
                <th>Lote</th>
                <th>Serie</th>
                <th>Caducidad</th>
                <th>Calidad</th>
                <th>Cantidad</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {alternativas.map((alt, idx) => (
                <tr key={idx}>
                  <td>{alt.ubicacion}</td>
                  <td>{alt.lote || '-'}</td>
                  <td>{alt.serie || '-'}</td>
                  <td>{alt.caducidad || '-'}</td>
                  <td>{alt.calidad || '-'}</td>
                  <td>{alt.cantidad}</td>
                  <td>
                    <button onClick={() => {
                      setUbicacionSugerida(alt);
                      setMostrarAlternativas(false);
                    }}>Seleccionar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => setMostrarAlternativas(false)}>Cancelar y volver</button>
        </div>
      );
    }

    // Return de prueba para flujo de picking dirigido
    // console.log('Return: Picking dirigido activo');
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 520, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Picking dirigido
          </Typography>
          {/* Paso 1: Información del producto y ubicación sugerida */}
          {wizardStep === 1 && (
            <>
              <Box mb={2}>
                <Typography fontWeight={600} color="#0057B8">SKU:</Typography>
                <Typography fontFamily="monospace" mb={1}>{prodCat?.codigo_producto || prod.producto_id}</Typography>
                <Typography fontWeight={600} color="#0057B8">Descripción:</Typography>
                <Typography mb={1}>{prodCat?.descripcion || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Cantidad a pickear:</Typography>
                <Typography mb={1}>{prod.cantidad}</Typography>
                {prod.lote && (
                  <>
                    <Typography fontWeight={600} color="#0057B8">Lote:</Typography>
                    <Typography mb={1}>{prod.lote}</Typography>
                  </>
                )}
                {prod.caducidad && (
                  <>
                    <Typography fontWeight={600} color="#0057B8">Caducidad:</Typography>
                    <Typography mb={1}>{prod.caducidad}</Typography>
                  </>
                )}
                {ubicacionValida && (
                  <>
                    <Typography fontWeight={600} color="#0057B8">Ubicación sugerida:</Typography>
                    <Typography mb={1}>{ubicacionValida.ubicacion}</Typography>
                  </>
                )}
              </Box>
              <Box display="flex" flexDirection="row" gap={2} width="100%" justifyContent="center">
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => setWizardStep(2)}
                >
                  Siguiente
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => {
                    setResumenPicking([...resumenPicking, { ...prod, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true }]);
                    setProductosPicking(arr => arr.map((p, idx) => idx === pickingIndex ? { ...p, pickeado: true, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true } : p));
                    setPickingIndex(pickingIndex + 1);
                    setCantidadPickeada('');
                    setUbicacionEscaneada('');
                    setUbicacionValidaOk(false);
                    setPickingConfirmado(false);
                    setWizardStep(1);
                  }}
                >
                  Omitir producto
                </Button>
              </Box>
            </>
          )}
          {/* Paso 2: Confirmación de ubicación */}
          {wizardStep === 2 && (
            <>
              <Box mb={2} width="100%" display="flex" flexDirection="column" alignItems="center">
                <Typography color="text.secondary" fontSize={16} mb={1}>
                  Escanea o ingresa la ubicación sugerida
                </Typography>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" minHeight={100}>
                  {/* Input invisible solo para escáneres */}
                  <input
                    ref={inputUbicacionRef}
                    type="text"
                    value={ubicacionEscaneada}
                    onChange={e => setUbicacionEscaneada(e.target.value.replace(/'/g, '-'))}
                    autoFocus
                    style={{ opacity: 0, position: 'absolute', left: -9999 }}
                    onBlur={e => inputUbicacionRef.current && inputUbicacionRef.current.focus()}
                  />
                  <LocationOnOutlinedIcon sx={{ color: '#0057B8', fontSize: 56, mt: 2, mb: 2 }} />
                  {/* Valor escaneado en grande */}
                  {ubicacionEscaneada && (
                    <Box mt={1} display="flex" alignItems="center" gap={1}>
                      <Typography fontSize={32} fontWeight={700} color="#0057B8">{ubicacionEscaneada}</Typography>
                      {ubicacionEscaneada.trim().toUpperCase() === ubicacionValida.ubicacion.trim().toUpperCase() ? (
                        <span style={{ color: 'green', fontSize: 32, fontWeight: 700, marginLeft: 8 }}>✔</span>
                      ) : (
                        <span style={{ color: 'red', fontSize: 32, fontWeight: 700, marginLeft: 8 }}>✖</span>
                      )}
                    </Box>
                  )}
                </Box>
                {errorPicking && <Typography color="error" mb={1}>{errorPicking}</Typography>}
              </Box>
              <Box display="flex" flexDirection="row" gap={2} width="100%" justifyContent="center">
                <Button
                  variant="outlined"
                  color="error"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => {
                    setResumenPicking([...resumenPicking, { ...prod, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true }]);
                    setProductosPicking(arr => arr.map((p, idx) => idx === pickingIndex ? { ...p, pickeado: true, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true } : p));
                    setPickingIndex(pickingIndex + 1);
                    setCantidadPickeada('');
                    setUbicacionEscaneada('');
                    setUbicacionValidaOk(false);
                    setPickingConfirmado(false);
                    setWizardStep(1);
                  }}
                >
                  Omitir producto
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => {
                    if (ubicacionEscaneada.trim().toUpperCase() === ubicacionValida.ubicacion.trim().toUpperCase()) {
                      setUbicacionValidaOk(true);
                      setErrorPicking('');
                      setWizardStep(3);
                    } else {
                      setUbicacionValidaOk(false);
                      setErrorPicking('Ubicación incorrecta, escanea la sugerida');
                    }
                  }}
                  disabled={!ubicacionEscaneada}
                >
                  Siguiente
                </Button>
              </Box>
            </>
          )}
          {/* Paso 3: Confirmación de cantidad */}
          {wizardStep === 3 && (
            <>
              <Box mb={2} width="100%">
                <Typography color="text.secondary" fontSize={16} mb={1}>
                  Ingresa la cantidad pickeada
                </Typography>
                <input
                  type="number"
                  min={1}
                  max={prod.cantidad}
                  value={cantidadPickeada}
                  onChange={e => setCantidadPickeada(e.target.value)}
                  className="w-full border-2 border-blue-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mb-4"
                  placeholder="Cantidad pickeada"
                  autoFocus
                />
              </Box>
              <Box display="flex" flexDirection="row" gap={2} width="100%" justifyContent="center">
                <Button
                  variant="contained"
                  color="success"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => {
                    if (!cantidadPickeada || isNaN(Number(cantidadPickeada)) || Number(cantidadPickeada) < 1 || Number(cantidadPickeada) > prod.cantidad) return;
                    setResumenPicking([...resumenPicking, { ...prod, sku: prod.sku || prod.codigo_producto, cantidad_pick: Number(cantidadPickeada), ubicacion_pick: ubicacionValida.ubicacion }]);
                    setProductosPicking(arr => arr.map((p, idx) => idx === pickingIndex ? { ...p, pickeado: true, sku: prod.sku || prod.codigo_producto, cantidad_pick: Number(cantidadPickeada), ubicacion_pick: ubicacionValida.ubicacion } : p));
                    setPickingIndex(pickingIndex + 1);
                    setCantidadPickeada('');
                    setUbicacionEscaneada('');
                    setUbicacionValidaOk(false);
                    setPickingConfirmado(false);
                    setWizardStep(1);
                  }}
                  disabled={!cantidadPickeada || isNaN(Number(cantidadPickeada)) || Number(cantidadPickeada) < 1 || Number(cantidadPickeada) > prod.cantidad}
                >
                  Confirmar picking
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mb: 2 }}
                  onClick={() => {
                    setResumenPicking([...resumenPicking, { ...prod, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true }]);
                    setProductosPicking(arr => arr.map((p, idx) => idx === pickingIndex ? { ...p, pickeado: true, sku: prod.sku || prod.codigo_producto, cantidad_pick: 0, ubicacion_pick: null, omitido: true } : p));
                    setPickingIndex(pickingIndex + 1);
                    setCantidadPickeada('');
                    setUbicacionEscaneada('');
                    setUbicacionValidaOk(false);
                    setPickingConfirmado(false);
                    setWizardStep(1);
                  }}
                >
                  Omitir producto
                </Button>
              </Box>
            </>
          )}
          {wizardStep === 4 && (
            <>
              <Box mb={2} width="100%" display="flex" flexDirection="column" alignItems="center">
                <Typography color="text.secondary" fontSize={18} mb={2}>
                  Escanea o selecciona la ubicación final (staging) para la mercancía pickeada
                </Typography>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" minHeight={100}>
                  <input
                    ref={inputStagingRef}
                    type="text"
                    value={ubicacionStaging}
                    onChange={e => setUbicacionStaging(e.target.value.replace(/'/g, '-'))}
                    autoFocus
                    style={{ opacity: 0, position: 'absolute', left: -9999 }}
                    onBlur={e => inputStagingRef.current && inputStagingRef.current.focus()}
                    onKeyDown={async e => {
                      if (e.key === 'Enter' && e.target.value.trim()) {
                        const valor = e.target.value.trim().replace(/'/g, '-');
                        console.log('=== ESCANEANDO STAGE ===');
                        console.log('Valor escaneado:', valor);
                        console.log('Resumen picking actual:', resumenPicking);
                        console.log('Productos pickeados:', resumenPicking.filter(item => !item.omitido && item.cantidad_pick && item.cantidad_pick > 0));
                        setUbicacionStaging(valor);
                        // Validar que exista la ubicación de staging
                        try {
                          const ubicStaging = await getWmsUbicacionByCodigo(valor);
                          if (!ubicStaging || !ubicStaging.id) {
                            setMensajeFinalPicking('Área de staging no encontrada');
                            setEstadoFinalPicking('error');
                            return;
                          }
                          setEstadoFinalPicking(null);
                          setMensajeFinalPicking('');
                          // Llamar a finalizarPicking automáticamente
                          console.log('Llamando a finalizarPicking con:', { valor, resumenPicking });
                          await finalizarPicking(valor, resumenPicking);
                        } catch (err) {
                          console.error('Error al validar o finalizar:', err);
                          setMensajeFinalPicking('Error al validar el área de staging');
                          setEstadoFinalPicking('error');
                        }
                      }
                    }}
                  />
                  <LocationOnOutlinedIcon sx={{ color: '#0057B8', fontSize: 56, mt: 2, mb: 2 }} />
                  {ubicacionStaging && (
                    <Box mt={1} display="flex" alignItems="center" gap={1}>
                      <Typography fontSize={32} fontWeight={700} color="#0057B8">{ubicacionStaging}</Typography>
                      <span style={{ color: 'green', fontSize: 32, fontWeight: 700, marginLeft: 8 }}>✔</span>
                    </Box>
                  )}
                </Box>
              </Box>
              {/* Eliminar el botón de finalizar picking aquí */}
            </>
          )}
        </Card>
      </Paper>
    );
  }
  // Mostrar pantalla de 'no hay inventario' solo si pickingActivo y pickingReady están activos y productosPicking.length === 0
  if (
    flowKey === 'picking' &&
    pickingActivo &&
    pickingReady &&
    productosPicking &&
    productosPicking.length === 0
  ) {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
        <h2>No hay inventario disponible para picking</h2>
      </div>
    );
  }
  if (flowKey === 'picking' && pickingActivo && pickingReady && productosPicking.length > 0 && pickingIndex >= productosPicking.length && wizardStep !== 4) {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 520, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Resumen de Picking
          </Typography>
          <Box width="100%" px={2} mb={2}>
            <table className="w-full text-sm mb-4">
              <thead>
                <tr className="bg-neutral-100">
                  <th className="px-2 py-1">SKU</th>
                  <th className="px-2 py-1">Descripción</th>
                  <th className="px-2 py-1">Cantidad orden</th>
                  <th className="px-2 py-1">Cantidad pickeada</th>
                  <th className="px-2 py-1">Ubicación</th>
                </tr>
              </thead>
              <tbody>
                {resumenPicking.map((p, idx) => {
                  const prodCat = catalogoProductos.find(pc => String(pc.id) === String(p.producto_id));
                  return (
                    <tr key={idx} className="border-b">
                      <td className="px-2 py-1 font-mono">{prodCat?.codigo_producto || p.producto_id}</td>
                      <td className="px-2 py-1">{prodCat?.descripcion || '-'}</td>
                      <td className="px-2 py-1 text-center">{p.cantidad}</td>
                      <td className="px-2 py-1 text-center font-bold">{p.cantidad_pick}</td>
                      <td className="px-2 py-1 text-center">{p.ubicacion_pick}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Box>
          <Button
            variant="contained"
            color="success"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2, width: '100%' }}
            onClick={() => setWizardStep(4)}
          >
            Finalizar picking
          </Button>
        </Card>
      </Paper>
    );
  }
  // 2. Paso de escaneo de stage destino después del resumen
  if (flowKey === 'picking' && pickingActivo && pickingReady && productosPicking.length > 0 && pickingIndex >= productosPicking.length && wizardStep === 4) {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 520, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Escanea la ubicación final (staging) para la mercancía pickeada
          </Typography>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" minHeight={100}>
            <input
              ref={inputStagingRef}
              type="text"
              value={ubicacionStaging}
              onChange={e => setUbicacionStaging(e.target.value.replace(/'/g, '-'))}
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => inputStagingRef.current && inputStagingRef.current.focus()}
              onKeyDown={e => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  setUbicacionStaging(e.target.value.trim().replace(/'/g, '-'));
                  finalizarPicking(e.target.value.trim().replace(/'/g, '-'), resumenPicking);
                }
              }}
            />
            <LocationOnOutlinedIcon sx={{ color: '#0057B8', fontSize: 56, mt: 2, mb: 2 }} />
            {ubicacionStaging && (
              <Box mt={1} display="flex" alignItems="center" gap={1}>
                <Typography fontSize={32} fontWeight={700} color="#0057B8">{ubicacionStaging}</Typography>
                <span style={{ color: 'green', fontSize: 32, fontWeight: 700, marginLeft: 8 }}>✔</span>
              </Box>
            )}
          </Box>
        </Card>
      </Paper>
    );
  }

  // returns condicionales DESPUÉS de los hooks
  if (!flow || !Array.isArray(flow.steps)) {
    console.error('Error: flow o flow.steps es undefined o no es un array', { flow, steps: flow?.steps, flowKey });
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50 p-4">
        <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md animate-fade-in text-center">
          <div className="text-2xl font-bold text-red-700 mb-4">Error de flujo</div>
          <div className="mb-4 text-red-600">No se encontró la definición del flujo <b>{flowKey}</b> o los pasos no están definidos correctamente. Verifica la URL, el flujo o contacta a soporte.</div>
          <button className="px-4 py-2 bg-blue-600 text-white rounded w-full" onClick={() => navigate(-1)}>Volver</button>
        </div>
      </div>
    );
  }
  if (!step) {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            ¡Recepción finalizada!
          </Typography>
          <Typography fontSize={18} color="text.secondary" textAlign="center" mb={2}>
            Has completado todos los pasos del flujo.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
            onClick={() => navigate('/wms/recepcion')}
          >
            Volver a la lista
          </Button>
        </Card>
      </Paper>
    );
  }

  const handleInput = (e) => {
    setFormData({ ...formData, [step.field]: e.target.value });
    setError('');
  };

  const handleNext = () => {
    if (step.validation?.required && !formData[step.field]) {
      setError('Este campo es obligatorio');
      return;
    }
    if (step.inputType === 'number' && step.validation?.min !== undefined) {
      if (Number(formData[step.field]) < step.validation.min) {
        setError(`El valor debe ser mayor o igual a ${step.validation.min}`);
        return;
      }
    }
    if (esRecepcionPedidos && step.field === 'cantidad') {
      setStepIndex(stepIndex + 1);
      return;
    }
    setStepIndex(stepIndex + 1);
  };

  const handleBack = () => {
    if (stepIndex === 0) return navigate(-1);
    setStepIndex(stepIndex - 1);
    setError('');
  };

  const handleConfirm = () => {
    // Aquí puedes hacer la llamada a la API para guardar el flujo
    alert('¡Flujo completado!\n' + JSON.stringify(formData, null, 2));
    navigate('/wms/inventario');
  };

  // --- Lógica para escaneo múltiple de CÓDIGO DE BARRAS (UPC/EAN) ---
  const handleScanMultipleSku = async (e) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      // Normalizar: reemplazar comillas simples por guiones
      const codigoBarras = e.target.value.trim().replace(/'/g, '-');
      try {
        const producto = await getWmsProductoBySku(codigoBarras);
        const sku = producto.sku || producto.codigo_producto;
        if (!producto || !sku) {
          setError('Producto no encontrado');
          setConfirmacionVisual('error');
          setTimeout(() => setConfirmacionVisual(null), 700);
          return;
        }
        setDescripcionSku(prev => ({ ...prev, [codigoBarras]: producto.descripcion || producto.nombre || 'Sin descripción' }));
        setProductosEscaneados(prev => {
          const idx = prev.findIndex(p => p.sku === sku);
          if (idx !== -1) {
            const updated = [...prev];
            updated[idx].cantidad += 1;
            return updated;
          } else {
            return [...prev, { sku, descripcion: producto.descripcion || producto.nombre || 'Sin descripción', cantidad: 1 }];
          }
        });
        setError('');
        setConfirmacionVisual('exito');
        setTimeout(() => setConfirmacionVisual(null), 700);
      } catch (err) {
        setError('Error al buscar producto por código de barras');
        setConfirmacionVisual('error');
        setTimeout(() => setConfirmacionVisual(null), 700);
      }
      e.target.value = '';
    }
  };
  const handleRemoveSku = (sku) => {
    setProductosEscaneados(prev => prev.filter(p => p.sku !== sku));
  };

  // Cuando se presiona Siguiente en scan-multiple-sku, iniciar flujo de lotes
  const handleScanMultipleNext = () => {
    if (productosEscaneados.length === 0) {
      setError('Escanea al menos un producto');
      return;
    }
    // Agrupar por SKU
    const agrupados = {};
    productosEscaneados.forEach(p => {
      if (!agrupados[p.sku]) agrupados[p.sku] = 0;
      agrupados[p.sku] += p.cantidad;
    });
    const skus = Object.keys(agrupados);
    if (skus.length > 0) {
      setFormData({ ...formData, productos: productosEscaneados });
      setLoteStep({ active: true, skuIndex: 0, unidadIndex: 0, mismoLote: true });
    } else {
      setError('Escanea al menos un producto');
    }
  };

  // Paso de escaneo de ubicación (dejarlo como primer paso)
  if (flowKey === 'verificacion-ubicacion' && stepIndex === 0) {
    // Render original del paso de escaneo de ubicación
    // ... reutilizar el render del paso scan para ubicación ...
    // Copiar la lógica del paso scan para field === 'ubicacion'
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Escanea la ubicación
          </Typography>
          <input
            ref={scanSkuInputRef}
            type="text"
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            onKeyDown={async (e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                const valor = e.target.value.trim().replace(/'/g, '-');
                try {
                  const ubicacion = await getWmsUbicacionByCodigo(valor);
                  if (!ubicacion || !ubicacion.codigo) {
                    setError('Ubicación no encontrada');
                    e.target.value = '';
                    return;
                  }
                  setFormData({ ...formData, ubicacion: ubicacion.codigo });
                  setError('');
                  setStepIndex(1); // Avanza al paso de selección de tipo de verificación
                } catch {
                  setError('Ubicación no encontrada');
                  e.target.value = '';
                }
              }
            }}
            disabled={false}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              Escanea o ingresa la ubicación
            </Typography>
          </Box>
          {error && <Typography color="error" mb={2}>{error}</Typography>}
        </Card>
      </Paper>
    );
  }
  // Paso de selección de tipo de verificación (ahora stepIndex === 1)
  if (flowKey === 'verificacion-ubicacion' && stepIndex === 1 && !modoVerificacion) {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-cog text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            ¿Qué tipo de verificación deseas realizar?
          </Typography>
          <Box width="100%" px={2} mb={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700, fontSize: 18, py: 2, px: 4, mb: 3, width: '100%' }}
              onClick={() => { setModoVerificacion('basica'); setStepIndex(2); }}
            >
              Verificación rápida
            </Button>
            <Typography color="text.secondary" fontSize={15} textAlign="center" mb={2}>
              Solo producto y cantidad. Ideal para conteos rápidos o auditorías visuales.
            </Typography>
            <Button
              variant="contained"
              color="success"
              sx={{ fontWeight: 700, fontSize: 18, py: 2, px: 4, width: '100%' }}
              onClick={() => { setModoVerificacion('completa'); setStepIndex(2); }}
            >
              Verificación detallada
            </Button>
            <Typography color="text.secondary" fontSize={15} textAlign="center" mt={2}>
              Producto, cantidad, lote, estado de calidad, número de serie, caducidad (todos opcionales). Para trazabilidad y control total.
            </Typography>
          </Box>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo múltiple de productos (SKU)
  if (step.type === 'scan-multiple-sku') {
    if (confirmacionVisual === 'exito') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-green-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✔</span>
          <div className="text-white text-2xl font-bold">Producto añadido</div>
        </div>
      );
    }
    if (confirmacionVisual === 'error') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✖</span>
          <div className="text-white text-2xl font-bold">Producto no encontrado</div>
        </div>
      );
    }
    // Si modoVerificacion es 'basica', saltar la pantalla de lote y avanzar directo
    if (modoVerificacion === 'basica') {
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
            <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
              <span className="pi pi-barcode text-green-600 text-4xl mr-2" style={{ fontSize: 48 }} />
            </Box>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
              {step.label}
            </Typography>
            <input
              ref={scanSkuInputRef}
              type="text"
              inputMode="none"
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
              onKeyDown={handleScanMultipleSku}
              disabled={false}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">
                {step.placeholder || 'Escanea los SKUs encontrados (puedes repetir para sumar cantidades)'}
              </Typography>
            </Box>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            {/* Lista de productos escaneados */}
            <Box width="100%" px={2} mb={2}>
              {productosEscaneados.length > 0 && (
                <Box mb={1}>
                  <Typography fontWeight={600} fontSize={16} color="#0057B8">Productos escaneados:</Typography>
                  <ul className="divide-y divide-gray-200">
                    {productosEscaneados.map((p, idx) => (
                      <li key={idx} className="flex items-center justify-between py-1">
                        <span className="font-mono text-xs">{p.sku}</span>
                        <span className="text-xs text-gray-500 ml-2">{p.descripcion}</span>
                        <span className="text-xs font-bold ml-2">x{p.cantidad}</span>
                        <Button size="small" color="error" onClick={() => handleRemoveSku(p.sku)} sx={{ minWidth: 0, ml: 1, p: 0.5 }}>Eliminar</Button>
                      </li>
                    ))}
                  </ul>
                </Box>
              )}
            </Box>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
              onClick={() => {
                if (productosEscaneados.length === 0) {
                  setError('Escanea al menos un producto');
                  return;
                }
                setFormData({ ...formData, productos: productosEscaneados });
                setStepIndex(stepIndex + 1);
              }}
            >
              Siguiente
            </Button>
          </Card>
        </Paper>
      );
    }
    // Render de captura de lote y estado de calidad (nuevo diseño)
    if (loteStep.active && flowKey === 'verificacion-ubicacion') {
      // Definir agrupados, skus, skuActual, cantidadSku y handleGuardarLote en este scope
      const agrupados = {};
      productosEscaneados.forEach(p => {
        if (!agrupados[p.sku]) agrupados[p.sku] = 0;
        agrupados[p.sku] += p.cantidad;
      });
      const skus = Object.keys(agrupados);
      const skuActual = skus[loteStep.skuIndex];
      const cantidadSku = agrupados[skuActual];
      const handleGuardarLote = () => {
        if (!inputLoteData.lote) {
          setInputLoteData(d => ({ ...d, errorLote: 'El lote es obligatorio' }));
          setConfirmacionLote('error');
          setTimeout(() => setConfirmacionLote(null), 700);
          return;
        }
        setLotesPorSku(prev => {
          const nuevos = { ...prev };
          if (!nuevos[skuActual]) nuevos[skuActual] = [];
          if (loteStep.mismoLote) {
            nuevos[skuActual].push({ lote: inputLoteData.lote, estado_calidad: inputLoteData.estadoCalidad, cantidad: cantidadSku });
          } else {
            nuevos[skuActual].push({ lote: inputLoteData.lote, estado_calidad: inputLoteData.estadoCalidad, cantidad: 1 });
          }
          return nuevos;
        });
        setInputLoteData({ lote: '', estadoCalidad: 'Liberado', errorLote: '' });
        setConfirmacionLote('exito');
        setTimeout(() => {
          setConfirmacionLote(null);
          // Siguiente paso: siguiente SKU o siguiente unidad
          if (loteStep.mismoLote || loteStep.unidadIndex + 1 >= cantidadSku) {
            // Siguiente SKU
            if (loteStep.skuIndex + 1 < skus.length) {
              setLoteStep({ active: true, skuIndex: loteStep.skuIndex + 1, unidadIndex: 0, mismoLote: true });
            } else {
              // Terminar flujo de lotes
              setLoteStep({ active: false, skuIndex: 0, unidadIndex: 0, mismoLote: true });
              // Unir info de lotes a productos y pasar a comparación
              const productosFinal = [];
              Object.entries(lotesPorSku).forEach(([sku, arr]) => {
                arr.forEach(info => {
                  productosFinal.push({ sku, ...info });
                });
              });
              setFormData({ ...formData, productos: productosFinal });
              setStepIndex(stepIndex + 1);
            }
          } else {
            // Siguiente unidad del mismo SKU
            setLoteStep(s => ({ ...s, unidadIndex: s.unidadIndex + 1 }));
            setInputLoteData({ lote: '', estadoCalidad: 'A', errorLote: '' });
          }
        }, 700);
      };
      if (confirmacionLote === 'exito') {
        return (
          <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-green-500 z-50 animate-fade-in">
            <span className="text-white text-8xl mb-4">✔</span>
            <div className="text-white text-2xl font-bold">Lote guardado</div>
          </div>
        );
      }
      if (confirmacionLote === 'error') {
        return (
          <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-500 z-50 animate-fade-in">
            <span className="text-white text-8xl mb-4">✖</span>
            <div className="text-white text-2xl font-bold">El lote es obligatorio</div>
          </div>
        );
      }
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
            <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
              <span className="pi pi-pencil text-green-500 text-4xl mr-2" style={{ fontSize: 48 }} />
            </Box>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
              Captura de lote y calidad
            </Typography>
            <Box mb={2} width="100%">
              <Typography fontWeight={600} fontSize={16} color="#0057B8" mb={1}>
                SKU: <span className="font-mono">{skuActual}</span> &nbsp;|&nbsp; Cantidad: <span className="font-mono">{loteStep.mismoLote ? cantidadSku : 1}</span>
              </Typography>
            </Box>
            <Box mb={2} width="100%">
              <Typography color="text.secondary" fontSize={16} mb={1}>
                Número de lote
              </Typography>
              <input
                className="w-full border-2 border-blue-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={inputLoteData.lote}
                onChange={e => setInputLoteData(d => ({ ...d, lote: e.target.value }))}
                autoFocus
                placeholder="Escanea o ingresa el lote"
              />
            </Box>
            <Box mb={2} width="100%">
              <Typography color="text.secondary" fontSize={16} mb={1}>
                Estado de calidad
              </Typography>
              <select
                className="w-full border-2 border-green-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-green-400"
                value={inputLoteData.estadoCalidad}
                onChange={e => setInputLoteData(d => ({ ...d, estadoCalidad: e.target.value }))}
              >
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </select>
            </Box>
            {inputLoteData.errorLote && <Typography color="error" mb={2} fontSize={18} fontWeight={700}>{inputLoteData.errorLote}</Typography>}
            <Button
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2, width: '100%' }}
              onClick={handleGuardarLote}
            >
              Guardar {loteStep.mismoLote ? 'lote' : 'unidad'}
            </Button>
          </Card>
        </Paper>
      );
    }
    const agrupados = {};
productosEscaneados.forEach(p => {
  if (!agrupados[p.sku]) agrupados[p.sku] = 0;
  agrupados[p.sku] += p.cantidad;
});
const skus = Object.keys(agrupados);
const skuActual = skus[loteStep.skuIndex];
const cantidadSku = agrupados[skuActual];
const handleGuardarLote = () => {
  if (!inputLoteData.lote) {
    setInputLoteData(d => ({ ...d, errorLote: 'El lote es obligatorio' }));
    setConfirmacionLote('error');
    setTimeout(() => setConfirmacionLote(null), 700);
    return;
  }
  setLotesPorSku(prev => {
    const nuevos = { ...prev };
    if (!nuevos[skuActual]) nuevos[skuActual] = [];
    if (loteStep.mismoLote) {
      nuevos[skuActual].push({ lote: inputLoteData.lote, estado_calidad: inputLoteData.estadoCalidad, cantidad: cantidadSku });
    } else {
      nuevos[skuActual].push({ lote: inputLoteData.lote, estado_calidad: inputLoteData.estadoCalidad, cantidad: 1 });
    }
    return nuevos;
  });
  setInputLoteData({ lote: '', estadoCalidad: 'Liberado', errorLote: '' });
  setConfirmacionLote('exito');
  setTimeout(() => {
    setConfirmacionLote(null);
    // Siguiente paso: siguiente SKU o siguiente unidad
    if (loteStep.mismoLote || loteStep.unidadIndex + 1 >= cantidadSku) {
      // Siguiente SKU
      if (loteStep.skuIndex + 1 < skus.length) {
        setLoteStep({ active: true, skuIndex: loteStep.skuIndex + 1, unidadIndex: 0, mismoLote: true });
      } else {
        // Terminar flujo de lotes
        setLoteStep({ active: false, skuIndex: 0, unidadIndex: 0, mismoLote: true });
        // Unir info de lotes a productos y pasar a comparación
        const productosFinal = [];
        Object.entries(lotesPorSku).forEach(([sku, arr]) => {
          arr.forEach(info => {
            productosFinal.push({ sku, ...info });
          });
        });
        setFormData({ ...formData, productos: productosFinal });
        setStepIndex(stepIndex + 1);
      }
    } else {
      // Siguiente unidad del mismo SKU
      setLoteStep(s => ({ ...s, unidadIndex: s.unidadIndex + 1 }));
      setInputLoteData({ lote: '', estadoCalidad: 'A', errorLote: '' });
    }
  }, 700);
};
    return (

      
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-pencil text-green-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Captura de lote y calidad
          </Typography>
          <Box mb={2} width="100%">
            <Typography fontWeight={600} fontSize={16} color="#0057B8" mb={1}>
              SKU: <span className="font-mono">{skuActual}</span> &nbsp;|&nbsp; Cantidad: <span className="font-mono">{loteStep.mismoLote ? cantidadSku : 1}</span>
            </Typography>
          </Box>
          <Box mb={2} width="100%">
            <Typography color="text.secondary" fontSize={16} mb={1}>
              Número de lote
            </Typography>
            <input
              className="w-full border-2 border-blue-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={inputLoteData.lote}
              onChange={e => setInputLoteData(d => ({ ...d, lote: e.target.value }))}
              autoFocus
              placeholder="Escanea o ingresa el lote"
            />
          </Box>
          <Box mb={2} width="100%">
            <Typography color="text.secondary" fontSize={16} mb={1}>
              Estado de calidad
            </Typography>
            <select
              className="w-full border-2 border-green-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-green-400"
              value={inputLoteData.estadoCalidad}
              onChange={e => setInputLoteData(d => ({ ...d, estadoCalidad: e.target.value }))}
            >
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
          </Box>
          {inputLoteData.errorLote && <Typography color="error" mb={2} fontSize={18} fontWeight={700}>{inputLoteData.errorLote}</Typography>}
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2, width: '100%' }}
            onClick={handleGuardarLote}
          >
            Guardar {loteStep.mismoLote ? 'lote' : 'unidad'}
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo de productos (SKU) o ubicación
  if (step.type === 'scan' && step.field === 'sku') {
    // Mapear productos esperados con datos del catálogo
    const productosEsperados = (ordenEntrada?.productos || []).map(p => {
      const prodCat = catalogoProductos.find(prod => prod.id === (p.producto_id || p.producto));
      return {
        ...p,
        sku: p.sku || (prodCat ? prodCat.codigo_producto : ''),
        descripcion: p.descripcion || (prodCat ? prodCat.descripcion : ''),
      };
    });

    // Calcular productos esperados y recibidos por línea diferenciada
    const getLineaKey = (p) => [p.sku || p.codigo_producto || p.producto_id, p.lote, p.serie, p.caducidad, p.calidad].map(x => x || '-').join('|');
    const recibidosPorLinea = productosRecibidos.reduce((acc, p) => {
      const key = getLineaKey(p);
      acc[key] = (acc[key] || 0) + (p.cantidad || 1);
      return acc;
    }, {});

    // Handler de escaneo universal para ubicaciones y productos
    const handleScanUniversal = async (e) => {
      if (e.key === 'Enter' && scanInput.trim()) {
        setErrorScan('');
        const valor = scanInput.trim().replace(/'/g, '-');
        if (step.field === 'ubicacion') {
          try {
            const ubicacion = await getWmsUbicacionByCodigo(valor);
            if (!ubicacion || !ubicacion.codigo) {
              setErrorScan('Ubicación no encontrada');
              setScanInput('');
              return;
            }
            // Confirmación visual verde y avanzar
            setFormData({ ...formData, ubicacion: ubicacion.codigo });
            setScanInput('');
            setErrorScan('');
            setTimeout(() => setStepIndex(stepIndex + 1), 500);
          } catch (err) {
            setErrorScan('Ubicación no encontrada');
            setScanInput('');
          }
          return;
        }
        // Lógica original para SKU/productos
        try {
          const producto = await getWmsProductoBySku(valor);
          const sku = producto.sku || producto.codigo_producto;
          if (!sku) {
            setErrorScan('Producto no encontrado en catálogo');
            setScanInput('');
            return;
          }
          // Buscar todas las líneas de la orden para ese SKU
          const lineas = (ordenEntrada?.productos || []).filter(p =>
            String(p.sku) === String(sku) ||
            String(p.codigo_producto) === String(sku) ||
            String(p.producto_id) === String(producto.id)
          );
          if (lineas.length === 0) {
            setErrorScan('El producto no está en la orden');
            setScanInput('');
            return;
          }
          if (lineas.length === 1) {
            setProductosEscaneados(prev => [...prev, { ...lineas[0], sku, descripcion: producto.descripcion || producto.nombre || '-', codigo_barras: valor }]);
            setScanInput('');
            setErrorScan('');
            // NUEVO: Confirmación visual y avance automático
            setConfirmacionVisual('exito');
            setTimeout(() => {
              setConfirmacionVisual(null);
              setStepIndex(stepIndex + 1);
            }, 1000);
          } else {
            setModalSeleccion({ opciones: lineas, producto, codigoBarras: valor });
            setScanInput('');
          }
        } catch (err) {
          setErrorScan('Error al buscar producto por código de barras');
          setScanInput('');
          setConfirmacionVisual('error');
          setTimeout(() => setConfirmacionVisual(null), 2000);
        }
      }
    };

    // NUEVO: Render de confirmación visual para escaneo exitoso
    if (confirmacionVisual === 'exito') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-green-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✔</span>
          <div className="text-white text-2xl font-bold">Producto escaneado correctamente</div>
        </div>
      );
    }
    if (confirmacionVisual === 'error') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-600 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✖</span>
          <div className="text-white text-2xl font-bold">Error al buscar producto</div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
            <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
              <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
            </Box>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
              {step.label}
            </Typography>
            <input
              ref={scanSkuInputRef}
              type="text"
              value={scanInput}
              onChange={e => setScanInput(e.target.value)}
              inputMode="none"
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
              onKeyDown={handleScanUniversal}
              disabled={false}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">
                {step.placeholder || 'Escanea o ingresa el código'}
              </Typography>
            </Box>
            {errorScan && <Typography color="error" mb={2}>{errorScan}</Typography>}
          </Card>
          {/* Botón flotante tipo footer */}
          <Box sx={{ position: 'fixed', left: 0, bottom: 0, width: '100%', zIndex: 30 }}>
            <Button
              variant="contained"
              color="info"
              sx={{
                borderRadius: 0,
                width: '100%',
                minHeight: 48,
                boxShadow: 3,
                justifyContent: 'flex-end',
                px: 2
              }}
              onClick={() => setDrawerOpen(true)}
            >
              <span style={{ flex: 1 }}></span>
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" /></svg>
              </span>
            </Button>
          </Box>
        </Paper>
        {/* Drawer desde abajo */}
        {drawerOpen && (
          <div className="fixed inset-0 z-50 flex flex-col justify-end bg-black bg-opacity-30 animate-fade-in" style={{ width: '100vw' }}>
            <div ref={drawerRef} className="w-full bg-white rounded-t-2xl shadow-2xl animate-slide-up" style={{ minHeight: 220, maxHeight: '60vh', overflowY: 'auto', touchAction: 'none' }}>
              {/* Barra de drag visual */}
              <div
                className="w-full flex justify-center items-center py-2 cursor-pointer select-none"
                style={{ touchAction: 'none' }}
                onMouseDown={startDragDrawer}
                onTouchStart={startDragDrawer}
              >
                <div style={{ width: 48, height: 6, borderRadius: 3, background: '#bbb' }} />
              </div>
              <div className="flex justify-between items-center mb-2 px-4">
                <Typography fontWeight={700} fontSize={20} color="#0057B8">Productos esperados</Typography>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  sx={{ ml: 2, fontWeight: 700 }}
                  onClick={() => {
                    // Solo permitir finalizar si todos los productos han sido recibidos
                    if (productosEsperados.every(p => recibidosPorLinea[getLineaKey(p)] >= p.cantidad)) {
                      // Buscar el índice del paso de stagingArea
                      const idxStaging = flow.steps.findIndex(s => s.field === 'stagingArea');
                      if (idxStaging !== -1) {
                        setStepIndex(idxStaging);
                      } else {
                        setStepIndex(flow.steps.length); // fallback
                      }
                      setDrawerOpen(false);
                    }
                  }}
                  disabled={!productosEsperados.every(p => recibidosPorLinea[getLineaKey(p)] >= p.cantidad)}
                >
                  Finalizar recepción
                </Button>
              </div>
              <div className="px-4 pb-4">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-neutral-100">
                      <th className="px-2 py-1 text-left">SKU</th>
                      <th className="px-2 py-1 text-left">Descripción</th>
                      <th className="px-2 py-1 text-center">Lote</th>
                      <th className="px-2 py-1 text-center">Serie</th>
                      <th className="px-2 py-1 text-center">Caducidad</th>
                      <th className="px-2 py-1 text-center">Calidad</th>
                      <th className="px-2 py-1 text-center">Esperado</th>
                      <th className="px-2 py-1 text-center">Recibido</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productosEsperados.map((p, idx) => (
                      <tr key={getLineaKey(p)} className={recibidosPorLinea[getLineaKey(p)] >= p.cantidad ? 'bg-emerald-50' : ''}>
                        <td className="px-2 py-1 font-mono">{p.sku || p.codigo_producto || p.producto_id}</td>
                        <td className="px-2 py-1">{p.descripcion || '-'}</td>
                        <td className="px-2 py-1 text-center">{p.lote || '-'}</td>
                        <td className="px-2 py-1 text-center">{p.serie || '-'}</td>
                        <td className="px-2 py-1 text-center">{p.caducidad || '-'}</td>
                        <td className="px-2 py-1 text-center">{p.calidad || '-'}</td>
                        <td className="px-2 py-1 text-center">{p.cantidad}</td>
                        <td className="px-2 py-1 text-center font-bold">{recibidosPorLinea[getLineaKey(p)] || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Modal de selección de línea diferenciada */}
        {modalSeleccion && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-2xl min-w-[420px]" style={{maxWidth: 700, width: '95vw'}}>
              <h2 className="text-xl font-bold text-blue-700 mb-4 text-center">Selecciona la línea correcta</h2>
              <p className="mb-2 text-gray-700 text-center">El producto escaneado coincide con varias líneas de la orden. Elige la que corresponde según lote, serie, caducidad o calidad.</p>
              <div style={{overflowX: 'auto', width: '100%'}}>
                <table className="w-full text-sm mb-4" style={{fontSize: '0.95rem', minWidth: 520}}>
                  <thead>
                    <tr className="bg-neutral-100">
                      <th className="px-2 py-1">Lote</th>
                      <th className="px-2 py-1">Serie</th>
                      <th className="px-2 py-1">Caducidad</th>
                      <th className="px-2 py-1">Calidad</th>
                      <th className="px-2 py-1">Cantidad</th>
                      <th className="px-2 py-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalSeleccion.opciones.map((op, idx) => (
                      <tr key={idx} className="border-b">
                        <td className="px-2 py-1 text-center">{op.lote || '-'}</td>
                        <td className="px-2 py-1 text-center">{op.serie || '-'}</td>
                        <td className="px-2 py-1 text-center">{op.caducidad || '-'}</td>
                        <td className="px-2 py-1 text-center">{op.calidad || '-'}</td>
                        <td className="px-2 py-1 text-center">{op.cantidad}</td>
                        <td className="px-2 py-1 text-center">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                              setProductosEscaneados(prev => [...prev, { ...op, sku: modalSeleccion.producto.sku || modalSeleccion.producto.codigo_producto, descripcion: modalSeleccion.producto.descripcion || modalSeleccion.producto.nombre || '-', codigo_barras: modalSeleccion.codigoBarras }]);
                              setModalSeleccion(null);
                              setConfirmacionVisual('exito');
                              setTimeout(() => {
                                setConfirmacionVisual(null);
                                setStepIndex(stepIndex + 1);
                              }, 1000);
                            }}
                          >
                            Seleccionar
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Button variant="outlined" color="error" fullWidth onClick={() => setModalSeleccion(null)}>
                Cancelar
              </Button>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  // Paso: resumen de la orden
  if (step.type === 'resumen-orden') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Resumen de la orden
          </Typography>
          {ordenEntrada ? (
            <Box mb={2}>
              <Typography fontWeight={600} color="#0057B8">ID Documento:</Typography>
              <Typography fontFamily="monospace" mb={1}>{ordenEntrada.iddocumento || '-'}</Typography>
              <Typography fontWeight={600} color="#0057B8">Cliente:</Typography>
              <Typography mb={1}>{nombreCliente || '-'}</Typography>
              <Typography fontWeight={600} color="#0057B8">Almacén:</Typography>
              <Typography mb={1}>{nombreAlmacen || '-'}</Typography>
              <Typography fontWeight={600} color="#0057B8">Fecha:</Typography>
              <Typography mb={1}>{ordenEntrada.fecha || '-'}</Typography>
              <Typography fontWeight={600} color="#0057B8">Observaciones:</Typography>
              <Typography mb={1}>{ordenEntrada.observaciones || '-'}</Typography>
              <Typography fontWeight={600} color="#0057B8">Productos:</Typography>
              <Typography mb={1}>{ordenEntrada.productos?.length || 0}</Typography>
            </Box>
          ) : (
            <Typography color="error">No se ha encontrado la orden. Regresa y escanea nuevamente.</Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
            onClick={() => {
              setFormData({ ...formData, ordenEntrada });
              setStepIndex(stepIndex + 1);
            }}
            disabled={!ordenEntrada}
          >
            Iniciar Recepción
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo de orden (primer paso de recepción)
  if (step.type === 'scan-orden') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          {/* Icono visual de escaneo */}
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanOrderInputRef}
            type="text"
            value={scanOrderInput}
            onChange={e => setScanOrderInput(e.target.value)}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanOrderInputRef.current && scanOrderInputRef.current.focus()}
            disabled={loadingOrder}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el número de pedido para iniciar la recepción.'}
            </Typography>
          </Box>
          {ordenError && <Typography color="error" mb={2}>{ordenError}</Typography>}
          {loadingOrder && <Typography color="primary" mb={2}>Buscando orden...</Typography>}
          {ordenEntrada && (
            <Box mt={2}>
              <Typography color="success.main">Orden encontrada: {ordenEntrada.iddocumento}</Typography>
            </Box>
          )}
        </Card>
      </Paper>
    );
  }

  // Paso custom: comparación de inventario para verificación de ubicación
  if (step.type === 'compare-inventory') {
    return (
      <PasoCompararInventario
        ubicacion={formData.ubicacion}
        productos={formData.productos}
        onContinue={(diferencias) => {
          setFormData({ ...formData, diferencias });
          setStepIndex(stepIndex + 1);
        }}
        navigate={navigate}
      />
    );
  }

  // Paso: confirmación de ajuste de inventario
  if (step.type === 'confirm' && flowKey === 'verificacion-ubicacion') {
    const handleScanUbicacion = async (e) => {
      if (e.key === 'Enter' && e.target.value.trim()) {
        const valor = e.target.value.trim().replace(/'/g, '-');
        if (valor === formData.ubicacion) {
          setLoadingAjuste(true);
          setErrorAjuste('');
          try {
            const hayDiferencias = (formData.diferencias || []).some(d => d.diferencia);
            if (!hayDiferencias) {
              setEstadoConfirmacion('exito');
              setTimeout(() => {
                setLoadingAjuste(false);
                navigate('/wms/inventario');
              }, 1500);
              return;
            }
            // Obtener id de la ubicación
            const ubicacionObj = await getWmsUbicacionByCodigo(valor);
            if (!ubicacionObj || !ubicacionObj.id) throw new Error('No se encontró la ubicación en el sistema');
            const ubicacion_id = ubicacionObj.id;
            // Consultar inventario agrupado con IDs para obtener inventory_id
            const inventarioAgrupado = await consultarInventarioAgrupadoConIds({ ubicacion: valor });
            // Buscar la ubicación LOST del almacén actual
            let almacen_id = formData.almacen_id || formData.almacen || (ordenEntrada?.almacen_id);
            if (!almacen_id) {
              const almacenLS = localStorage.getItem('wms_warehouse');
              if (almacenLS) {
                try {
                  const almacenObj = JSON.parse(almacenLS);
                  almacen_id = almacenObj.warehouse_id;
                } catch {}
              }
            }
            const ubicaciones = await getWmsUbicaciones();
            const ubicLost = ubicaciones.find(u => u.codigo === 'LOST' && String(u.almacen_id) === String(almacen_id));
            if (!ubicLost) throw new Error('No se encontró la ubicación LOST para este almacén.');
            // Construir movimientos de ajuste
            const movimientos = [];
            for (const d of formData.diferencias) {
              let producto = formData.productos.find(p => p.sku === d.sku);
              let producto_id = producto?.producto_id;
              let cliente_id = null;
              let lote = (typeof producto?.lote !== 'undefined' && producto?.lote !== '') ? producto.lote : null;
              let estado_calidad = (typeof producto?.estado_calidad !== 'undefined' && producto?.estado_calidad !== '') ? producto.estado_calidad : (typeof producto?.estadoCalidad !== 'undefined' && producto?.estadoCalidad !== '') ? producto.estadoCalidad : null;
              const invMatch = inventarioAgrupado.find(inv => inv.sku === d.sku && inv.ubicacion_id === ubicacion_id && (inv.lote || '') === (lote || '') && (inv.estado_calidad || '') === (estado_calidad || ''));
              let inventory_id = invMatch && invMatch.ids && invMatch.ids.length > 0 ? invMatch.ids[0] : null;
              let cantidadEnInventario = invMatch ? invMatch.cantidad : 0;
              if (!producto_id) {
                const prod = await getWmsProductoBySku(d.sku);
                producto_id = prod?.id;
                cliente_id = prod?.cliente_id || prod?.cuenta_id;
              } else {
                cliente_id = producto?.cliente_id || producto?.cuenta_id;
              }
              if (!producto_id) throw new Error(`No se encontró el producto para SKU: ${d.sku}`);
              if (!cliente_id) throw new Error(`El producto ${d.sku} no tiene cliente asignado.`);
              // --- Lógica robusta ---
              if (!invMatch) {
                if (d.encontrado > 0) {
                  // Ingresar la cantidad encontrada
                  movimientos.push({
                    inventory_id: null,
                    producto_id,
                    cantidad: d.encontrado,
                    origen_id: null,
                    destino_id: ubicacion_id,
                    lote,
                    estado_calidad,
                    tipo: 'ajuste',
                    cliente_id,
                    fecha: new Date().toISOString(),
                    usuario_id: null,
                    referencia: null,
                    observaciones: null
                  });
                }
                if (d.encontrado < d.esperado) {
                  // Solo mover a LOST la diferencia
                  movimientos.push({
                    inventory_id: null,
                    producto_id,
                    cantidad: d.esperado - d.encontrado,
                    origen_id: null,
                    destino_id: ubicLost.id,
                    lote,
                    estado_calidad,
                    tipo: 'lost',
                    cliente_id,
                    fecha: new Date().toISOString(),
                    usuario_id: null,
                    referencia: null,
                    observaciones: null
                  });
                }
                // Si encontrado = 0 y esperado > 0, no hacer nada
                continue;
              }
              // Si hay inventario existente
              if (d.encontrado === d.esperado) {
                // No hacer nada
                continue;
              }
              if (d.encontrado > d.esperado) {
                // Ingresar la diferencia
                movimientos.push({
                  inventory_id: null,
                  producto_id,
                  cantidad: d.encontrado - d.esperado,
                  origen_id: null,
                  destino_id: ubicacion_id,
                  lote,
                  estado_calidad,
                  tipo: 'ajuste',
                  cliente_id,
                  fecha: new Date().toISOString(),
                  usuario_id: null,
                  referencia: null,
                  observaciones: null
                });
              }
              if (d.encontrado < d.esperado) {
                // Descontar hasta donde alcance el inventario
                const cantidadDescontar = Math.min(d.esperado - d.encontrado, cantidadEnInventario);
                if (cantidadDescontar > 0) {
                  movimientos.push({
                    inventory_id,
                    producto_id,
                    cantidad: cantidadDescontar,
                    origen_id: ubicacion_id,
                    destino_id: ubicLost.id,
                    lote,
                    estado_calidad,
                    tipo: 'lost',
                    cliente_id,
                    fecha: new Date().toISOString(),
                    usuario_id: null,
                    referencia: null,
                    observaciones: null
                  });
                }
                // Mover a LOST la diferencia faltante si aplica
                if ((d.esperado - d.encontrado) > cantidadEnInventario) {
                  movimientos.push({
                    inventory_id: null,
                    producto_id,
                    cantidad: (d.esperado - d.encontrado) - cantidadEnInventario,
                    origen_id: null,
                    destino_id: ubicLost.id,
                    lote,
                    estado_calidad,
                    tipo: 'lost',
                    cliente_id,
                    fecha: new Date().toISOString(),
                    usuario_id: null,
                    referencia: null,
                    observaciones: null
                  });
                }
              }
            }
            if (movimientos.length === 0) {
              setEstadoConfirmacion('exito');
              setTimeout(() => {
                setLoadingAjuste(false);
                navigate('/wms/inventario');
              }, 1500);
              return;
            }
            // Llamar a la API de movimientos
            await registrarMovimientoInventario(movimientos);
            setEstadoConfirmacion('exito');
            setTimeout(() => {
              setLoadingAjuste(false);
              navigate('/wms/inventario');
            }, 1500);
          } catch (err) {
            setErrorAjuste(err?.message || 'Error al afectar inventario');
            setEstadoConfirmacion('error');
            setTimeout(() => setEstadoConfirmacion(null), 1500);
            setLoadingAjuste(false);
          }
        } else {
          setEstadoConfirmacion('error');
          setTimeout(() => setEstadoConfirmacion(null), 1200);
        }
        setInputUbicacion('');
      }
    };
    if (estadoConfirmacion === 'exito') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-green-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✔</span>
          <div className="text-white text-2xl font-bold">¡Ajuste realizado con éxito!</div>
        </div>
      );
    }
    if (estadoConfirmacion === 'error') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✖</span>
          <div className="text-white text-2xl font-bold">{errorAjuste || 'Ubicación incorrecta, intenta de nuevo'}</div>
        </div>
      );
    }
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#e3f0ff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 520, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-check-circle text-green-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Escanea la ubicación para confirmar el ajuste
          </Typography>
          <Box width="100%" px={2} mb={2}>
            <Box sx={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f0f6ff' }}>
                    <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>SKU</th>
                    <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>Encontrado</th>
                    <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>Esperado</th>
                    <th style={{ padding: 8 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {(formData.diferencias || []).map((d) => (
                    <tr key={d.sku} style={{ background: d.diferencia ? (d.inesperado ? '#fffbe6' : '#fff') : '#e6ffe6' }}>
                      <td style={{ padding: 8, fontFamily: 'monospace', fontWeight: 600 }}>{d.sku}</td>
                      <td style={{ padding: 8, color: d.diferencia ? (d.encontrado > d.esperado ? '#16a34a' : d.encontrado < d.esperado ? '#dc2626' : '#0057B8') : '#16a34a', fontWeight: 700, fontSize: 18 }}>
                        {d.encontrado}
                      </td>
                      <td style={{ padding: 8, color: d.diferencia ? '#0057B8' : '#16a34a', fontWeight: 700, fontSize: 18 }}>{d.esperado}</td>
                      <td style={{ padding: 8 }}>
                        {d.inesperado && d.diferencia && (
                          <Typography color="warning.main" fontWeight={700}>Inesperado</Typography>
                        )}
                        {!d.diferencia && (
                          <Typography color="success.main" fontWeight={700}>OK</Typography>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Box>
          <input
            ref={inputRef}
            type="text"
            value={inputUbicacion}
            onChange={e => setInputUbicacion(e.target.value)}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => inputRef.current && inputRef.current.focus()}
            onKeyDown={handleScanUbicacion}
            disabled={loadingAjuste}
          />
          <Button
            variant="outlined"
            color="error"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2, width: '100%' }}
            onClick={() => navigate('/wms/inventario')}
            disabled={loadingAjuste}
          >
            Cancelar
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: input (cantidad recibida)
  if (step.type === 'input') {
    // Solo para recepcion-pedidos: obtener cantidad esperada del producto escaneado
    let cantidadEsperada = null;
    let lineaActual = null;
    if (esRecepcionPedidos && productosEscaneados.length > 0) {
      const ultimo = productosEscaneados[productosEscaneados.length - 1];
      cantidadEsperada = ultimo.cantidad;
      lineaActual = ultimo;
    }
    // Buscar el índice del paso de escaneo de producto (type: 'scan', field: 'sku')
    const pasoScanIndex = flow.steps.findIndex(s => s.type === 'scan' && s.field === 'sku');
    // Calcular si ya se recibieron todos los productos esperados
    const productosEsperados = (ordenEntrada?.productos || []);
    const todosRecibidos = productosEsperados.every(p => {
      // Suma recibida para esta línea diferenciada
      const recibidos = productosRecibidos
        .filter(r =>
          r.sku === (p.sku || p.codigo_producto) &&
          (r.lote || '') === (p.lote || '') &&
          (r.serie || '') === (p.serie || '') &&
          (r.caducidad || '') === (p.caducidad || '') &&
          (r.calidad || '') === (p.calidad || '')
        )
        .reduce((sum, r) => sum + (r.cantidad || 0), 0);
      return recibidos >= (p.cantidad || 0);
    });
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            type="number"
            min={step.validation?.min || 1}
            max={cantidadEsperada || undefined}
            value={formData[step.field] || ''}
            onChange={e => {
              let val = e.target.value;
              if (val === '' || isNaN(val)) {
                setFormData({ ...formData, [step.field]: '' });
                setError('');
                return;
              }
              val = Number(val);
              if (val < (step.validation?.min || 1)) {
                setError(`La cantidad debe ser al menos ${(step.validation?.min || 1)}`);
              } else if (cantidadEsperada && val > cantidadEsperada) {
                setError(`No puedes recibir más de la cantidad esperada (${cantidadEsperada})`);
              } else {
                setError('');
              }
              setFormData({ ...formData, [step.field]: val });
            }}
            className="w-full border-2 border-blue-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mb-4"
            placeholder={step.placeholder || 'Ingresa la cantidad recibida'}
            autoFocus
          />
          {error && <Typography color="error" mb={2}>{error}</Typography>}
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
            onClick={() => {
              if (!formData[step.field] || (step.validation?.min && Number(formData[step.field]) < step.validation.min)) {
                setError('La cantidad es obligatoria y debe ser válida');
                return;
              }
              if (cantidadEsperada && Number(formData[step.field]) > cantidadEsperada) {
                setError(`No puedes recibir más de la cantidad esperada (${cantidadEsperada})`);
                return;
              }
              setError('');
              // NUEVO: Registrar avance recibido por línea diferenciada
              if (esRecepcionPedidos && lineaActual) {
                setProductosRecibidos(prev => {
                  // Buscar si ya existe una línea igual
                  const idx = prev.findIndex(r =>
                    r.sku === lineaActual.sku &&
                    r.lote === lineaActual.lote &&
                    r.serie === lineaActual.serie &&
                    r.caducidad === lineaActual.caducidad &&
                    r.calidad === lineaActual.calidad
                  );
                  if (idx !== -1) {
                    // Sumar a la cantidad existente
                    const nuevos = [...prev];
                    nuevos[idx].cantidad += Number(formData[step.field]);
                    return nuevos;
                  } else {
                    // Agregar nueva línea
                    return [
                      ...prev,
                      {
                        sku: lineaActual.sku,
                        lote: lineaActual.lote,
                        serie: lineaActual.serie,
                        caducidad: lineaActual.caducidad,
                        calidad: lineaActual.calidad,
                        cantidad: Number(formData[step.field])
                      }
                    ];
                  }
                });
              }
              // Elimina el producto escaneado actual de la lista de pendientes
              setProductosEscaneados(prev => prev.slice(0, -1));
              // Limpiar el campo de cantidad para el siguiente producto
              setFormData({ ...formData, [step.field]: '' });
              // Regresar al paso de escaneo de producto
              setStepIndex(pasoScanIndex);
            }}
            disabled={!formData[step.field] || !!error}
          >
            Siguiente
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo de área de staging (input invisible)
  if (step.type === 'scan' && step.field === 'stagingArea') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/recepcion')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-map-marker text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanStagingInputRef}
            type="text"
            value={formData[step.field] || ''}
            onChange={e => setFormData({ ...formData, [step.field]: e.target.value })}
            onBlur={e => scanStagingInputRef.current && scanStagingInputRef.current.focus()}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onKeyDown={async (e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                const valor = e.target.value.trim().replace(/'/g, '-');
                // Validar que exista la ubicación de staging
                try {
                  const ubicacion = await getWmsUbicacionByCodigo(valor);
                  if (!ubicacion || !ubicacion.codigo) {
                    setError('Área de staging no encontrada');
                    setFormData({ ...formData, [step.field]: '' });
                    return;
                  }
                  setFormData({ ...formData, [step.field]: ubicacion.codigo });
                  setStagingArea(ubicacion.codigo);
                  setError('');
                  setTimeout(() => {
                    setFinalizado(true);
                    setStepIndex(stepIndex + 1);
                  }, 500);
                } catch {
                  setError('Área de staging no encontrada');
                  setFormData({ ...formData, [step.field]: '' });
                }
              }
            }}
            placeholder={step.placeholder || 'Escanea o ingresa el área de staging'}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el área de staging'}
            </Typography>
          </Box>
          {error && <Typography color="error" mb={2}>{error}</Typography>}
        </Card>
      </Paper>
    );
  }

  // Paso: consulta de inventario (primer paso)
  if (flowKey === 'consulta' && step && step.type === 'scan' && step.field === 'criterio') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={inputConsultaRef}
            type="text"
            value={formData.criterio || ''}
            onChange={e => {
              const valor = e.target.value.replace(/'/g, '-');
              setFormData({ ...formData, criterio: valor });
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' && formData.criterio?.trim()) {
                // Normalizar antes de avanzar
                setFormData(fd => ({ ...fd, criterio: (fd.criterio || '').replace(/'/g, '-') }));
                setStepIndex(stepIndex + 1);
              }
            }}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => inputConsultaRef.current && inputConsultaRef.current.focus()}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el SKU, ubicación o código de barras'}
            </Typography>
          </Box>
        </Card>
      </Paper>
    );
  }

  // Paso: confirmación de consulta de inventario
  if (flowKey === 'consulta' && step && step.type === 'confirm') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 700, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            Resultados de la consulta
          </Typography>
          {consultaInventarioLoading ? (
            <Typography color="primary" fontSize={18} mb={2}>Buscando inventario...</Typography>
          ) : consultaInventarioError ? (
            <Typography color="error" fontSize={18} mb={2}>{consultaInventarioError}</Typography>
          ) : consultaInventarioResultados.length === 0 ? (
            <Typography color="warning.main" fontSize={18} mb={2}>No se encontraron resultados para el criterio ingresado.</Typography>
          ) : (
            <Box width="100%" px={2} mb={2} sx={{ overflowX: 'auto' }}>
              <table className="min-w-full text-sm border border-neutral-200 rounded-lg bg-white">
                <thead>
                  <tr className="bg-neutral-100">
                    <th className="px-2 py-1">SKU</th>
                    <th className="px-2 py-1">Descripción</th>
                    <th className="px-2 py-1">Ubicación</th>
                    <th className="px-2 py-1">Lote</th>
                    <th className="px-2 py-1">Serie</th>
                    <th className="px-2 py-1">Calidad</th>
                    <th className="px-2 py-1">Cantidad</th>
                    <th className="px-2 py-1">Código Barras</th>
                  </tr>
                </thead>
                <tbody>
                  {consultaInventarioResultados.map((r, idx) => (
                    <tr key={idx} className="border-b">
                      <td className="px-2 py-1 font-mono">{r.sku}</td>
                      <td className="px-2 py-1">{r.descripcion}</td>
                      <td className="px-2 py-1">{r.ubicacion}</td>
                      <td className="px-2 py-1">{r.lote || '-'}</td>
                      <td className="px-2 py-1">{r.serie || '-'}</td>
                      <td className="px-2 py-1">{r.estado_calidad || '-'}</td>
                      <td className="px-2 py-1 text-right">{r.cantidad}</td>
                      <td className="px-2 py-1 font-mono">{r.codigo_barras || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
            onClick={() => navigate('/wms/inventario')}
          >
            Nueva consulta
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo múltiple de productos para paletizado (con validación de inventario)
  if (step.type === 'scan-multiple') {
    if (confirmacionVisual === 'exito') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-green-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✔</span>
          <div className="text-white text-2xl font-bold">Producto añadido</div>
        </div>
      );
    }
    if (confirmacionVisual === 'error') {
      return (
        <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-red-500 z-50 animate-fade-in">
          <span className="text-white text-8xl mb-4">✖</span>
          <div className="text-white text-2xl font-bold">{error || 'Producto no disponible en staging'}</div>
        </div>
      );
    }
    // Handler para escaneo múltiple en paletizado (con validación)
    const handleScanMultiple = async (e) => {
      if (e.key === 'Enter' && e.target.value.trim()) {
        const codigo = e.target.value.trim().replace(/'/g, '-');
        try {
          // Buscar producto en inventario de staging
          const inventario = inventarioStaging.find(inv => inv.sku === codigo || inv.codigo_barras === codigo);
          if (!inventario || (inventario.cantidad - (productosEscaneados.find(p => p.sku === inventario.sku)?.cantidad || 0)) <= 0) {
            setError('Producto no disponible o cantidad insuficiente en staging');
            setConfirmacionVisual('error');
            setTimeout(() => setConfirmacionVisual(null), 1200);
            return;
          }
          // Buscar datos de catálogo para descripción
          let producto = null;
          try {
            producto = await getWmsProductoBySku(inventario.sku);
          } catch {}
          const sku = inventario.sku;
          setDescripcionSku(prev => ({ ...prev, [sku]: producto?.descripcion || producto?.nombre || 'Sin descripción' }));
          setProductosEscaneados(prev => {
            const idx = prev.findIndex(p => p.sku === sku);
            if (idx !== -1) {
              // Validar que no se exceda la cantidad disponible
              if (prev[idx].cantidad + 1 > inventario.cantidad) {
                setError('No puedes agregar más de la cantidad disponible');
                setConfirmacionVisual('error');
                setTimeout(() => setConfirmacionVisual(null), 1200);
                return prev;
              }
              const updated = [...prev];
              updated[idx].cantidad += 1;
              return updated;
            } else {
              return [...prev, { sku, descripcion: producto?.descripcion || producto?.nombre || 'Sin descripción', cantidad: 1 }];
            }
          });
          setError('');
          setConfirmacionVisual('exito');
          setTimeout(() => setConfirmacionVisual(null), 700);
        } catch (err) {
          setError('Error al buscar producto en staging');
          setConfirmacionVisual('error');
          setTimeout(() => setConfirmacionVisual(null), 1200);
        }
        e.target.value = '';
      }
    };
    const handleRemove = (sku) => {
      setProductosEscaneados(prev => prev.filter(p => p.sku !== sku));
    };
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-green-600 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanSkuInputRef}
            type="text"
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            onKeyDown={handleScanMultiple}
            disabled={false}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea los productos para agregar al pallet'}
            </Typography>
          </Box>
          {loadingInventarioStaging && <Typography color="primary" mb={2}>Cargando inventario de staging...</Typography>}
          {errorInventarioStaging && <Typography color="error" mb={2}>{errorInventarioStaging}</Typography>}
          {/* Mostrar inventario disponible en staging */}
          {inventarioStaging.length > 0 && (
            <Box width="100%" px={2} mb={2}>
              <Typography fontWeight={600} fontSize={16} color="#0057B8">Disponibles en staging:</Typography>
              <ul className="divide-y divide-gray-200">
                {inventarioStaging.map((inv, idx) => {
                  const escaneados = productosEscaneados.find(p => p.sku === inv.sku)?.cantidad || 0;
                  return (
                    <li key={idx} className="flex items-center justify-between py-1">
                      <span className="font-mono text-xs">{inv.sku}</span>
                      <span className="text-xs text-gray-500 ml-2">{inv.descripcion || '-'}</span>
                      <span className="text-xs font-bold ml-2">{escaneados} / {inv.cantidad}</span>
                    </li>
                  );
                })}
              </ul>
            </Box>
          )}
          {/* Lista de productos escaneados para el pallet */}
          <Box width="100%" px={2} mb={2}>
            {productosEscaneados.length > 0 && (
              <Box mb={1}>
                <Typography fontWeight={600} fontSize={16} color="#0057B8">Productos en el pallet:</Typography>
                <ul className="divide-y divide-gray-200">
                  {productosEscaneados.map((p, idx) => (
                    <li key={idx} className="flex items-center justify-between py-1">
                      <span className="font-mono text-xs">{p.sku}</span>
                      <span className="text-xs text-gray-500 ml-2">{p.descripcion}</span>
                      <span className="text-xs font-bold ml-2">x{p.cantidad}</span>
                      {step.allowUndo && (
                        <Button size="small" color="error" onClick={() => handleRemove(p.sku)} sx={{ minWidth: 0, ml: 1, p: 0.5 }}>Eliminar</Button>
                      )}
                    </li>
                  ))}
                </ul>
              </Box>
            )}
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
            onClick={() => {
              if (productosEscaneados.length === 0) {
                setError('Escanea al menos un producto');
                return;
              }
              setFormData({ ...formData, productos: productosEscaneados });
              setStepIndex(stepIndex + 1);
            }}
          >
            Siguiente
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: escaneo genérico (por ejemplo, área de staging en paletizado)
  if (step.type === 'scan' && step.field === 'staging') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanSkuInputRef}
            type="text"
            value={formData[step.field] || ''}
            onChange={e => setFormData({ ...formData, [step.field]: e.target.value })}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            onKeyDown={async (e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                const valor = e.target.value.trim().replace(/'/g, '-');
                // Validar que exista la ubicación de staging
                try {
                  setLoadingInventarioStaging(true);
                  setError('');
                  setErrorInventarioStaging('');
                  const ubicacion = await getWmsUbicacionByCodigo(valor);
                  if (!ubicacion || !ubicacion.codigo) {
                    setError('Área de staging no encontrada');
                    setFormData({ ...formData, [step.field]: '' });
                    setInventarioStaging([]);
                    setLoadingInventarioStaging(false);
                    return;
                  }
                  setFormData({ ...formData, [step.field]: ubicacion.codigo });
                  setStagingArea(ubicacion.codigo);
                  // Consultar inventario solo al confirmar
                  const inventario = await consultarInventario({ ubicacion: ubicacion.codigo });
                  setInventarioStaging(Array.isArray(inventario) ? inventario : []);
                  setError('');
                  setTimeout(() => {
                    setStepIndex(stepIndex + 1);
                  }, 500);
                } catch {
                  setError('Área de staging no encontrada');
                  setFormData({ ...formData, [step.field]: '' });
                  setInventarioStaging([]);
                } finally {
                  setLoadingInventarioStaging(false);
                }
              }
            }}
            placeholder={step.placeholder || 'Escanea o ingresa el área de staging'}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el área de staging'}
            </Typography>
          </Box>
          {loadingInventarioStaging && <Typography color="primary" mb={2}>Cargando inventario de staging...</Typography>}
          {error && <Typography color="error" mb={2}>{error}</Typography>}
        </Card>
      </Paper>
    );
  }

  // Paso: resumen del pallet (summary)
  if (step.type === 'summary') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 480, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <Box width="100%" px={2} mb={2}>
            {formData.productos && formData.productos.length > 0 ? (
              <table className="w-full text-sm mb-4">
                <thead>
                  <tr className="bg-neutral-100">
                    <th className="px-2 py-1">SKU</th>
                    <th className="px-2 py-1">Descripción</th>
                    <th className="px-2 py-1">Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.productos.map((p, idx) => (
                    <tr key={idx} className="border-b">
                      <td className="px-2 py-1 font-mono">{p.sku}</td>
                      <td className="px-2 py-1">{p.descripcion}</td>
                      <td className="px-2 py-1 text-center font-bold">{p.cantidad}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <Typography color="warning.main" fontSize={18} mb={2}>No hay productos en el pallet.</Typography>
            )}
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
            onClick={() => setStepIndex(stepIndex + 1)}
            disabled={!formData.productos || formData.productos.length === 0}
          >
            Confirmar pallet
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: confirmación de paletizado (confirm)
  if (step.type === 'confirm') {
    // Nueva lógica: crear HU y luego movimientos de inventario
    const handleGenerarEtiqueta = async () => {
      setLoadingGenerar(true);
      setErrorGenerar('');
      try {
        // 1. Crear el HU (pallet)
        const palletCode = `PALLET-${Date.now()}`; // Puedes mejorar el generador de código
        const palletDesc = `Pallet generado desde staging`;
        const hu = await import('../../api.wms.hu').then(m => m.crearHU({
          codigo: palletCode,
          descripcion: palletDesc,
          tipo: 'Pallet',
        }));
        const huId = hu.id || hu.codigo;

        // 2. Preparar movimientos de inventario
        // Buscar inventario de staging para obtener los IDs y cantidades
        const inventario = await import('../../api.wms.inventario').then(m => m.consultarInventarioAgrupadoConIds({ ubicacion: formData.staging }));
        // Mapear productos seleccionados
        const productos = formData.productos || [];
        const movimientos = productos.map(prod => {
          // Buscar el registro de inventario correspondiente
          const inv = inventario.find(i => i.sku === prod.sku && i.lote === (prod.lote || '') && i.estado_calidad === (prod.estado_calidad || 'A'));
          if (!inv || !inv.ids || inv.ids.length === 0) throw new Error(`No se encontró inventario para SKU ${prod.sku}`);
          return {
            inventory_id: inv.ids[0],
            producto_id: inv.producto_id,
            cantidad: prod.cantidad,
            origen_id: inv.ubicacion_id,
            destino_id: inv.ubicacion_id,
            lote: inv.lote,
            estado_calidad: inv.estado_calidad,
            hu_id: huId,
            usuario_id: null, // Puedes obtener el usuario actual si lo tienes
            tipo: 'paletizado',
            fecha: new Date().toISOString(),
            referencia: palletCode,
            observaciones: 'Paletizado automático',
            cliente_id: inv.cliente_id // <-- Aseguramos que se envía el cliente_id correcto
          };
        });
        // Log para validar el payload
        console.log('Movimientos a enviar:', movimientos);
        // 3. Ejecutar movimientos
        await import('../../api.wms.inventario').then(m => m.registrarMovimientoInventario(movimientos));
        setStepIndex(stepIndex + 1);
      } catch (err) {
        setErrorGenerar(err?.message || 'Error al generar el pallet');
      } finally {
        setLoadingGenerar(false);
      }
    };

    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <Typography color="text.secondary" fontSize={16} textAlign="center" mb={2}>
            ¿Deseas confirmar el paletizado y generar la etiqueta?
          </Typography>
          {errorGenerar && <Typography color="error" mb={2}>{errorGenerar}</Typography>}
          <Button
            variant="contained"
            color="success"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
            onClick={handleGenerarEtiqueta}
            disabled={loadingGenerar}
          >
            {loadingGenerar ? 'Generando...' : 'Generar etiqueta'}
          </Button>
        </Card>
      </Paper>
    );
  }

  // Paso: etiqueta generada (generate-label)
  if (step.type === 'generate-label') {
    const handleReimprimirEtiqueta = () => {
      setReimpresionExito(true);
      setTimeout(() => setReimpresionExito(false), 1500);
      // Aquí iría la lógica real de reimpresión (API o función de impresión)
    };
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <Box mt={2} mb={2}>
            {/* Aquí iría la visualización de la etiqueta generada (placeholder) */}
            <Typography color="success.main" fontSize={18} mb={2}>¡Etiqueta generada para el pallet!</Typography>
            {reimpresionExito && (
              <Typography color="info.main" fontSize={16} mb={2}>Etiqueta reimpresa correctamente</Typography>
            )}
          </Box>
          <Button
            variant="contained"
            color="secondary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 1, mb: 2 }}
            onClick={handleReimprimirEtiqueta}
          >
            Reimprimir etiqueta
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 1, mb: 2 }}
            onClick={() => navigate('/wms/inventario')}
          >
            Finalizar
          </Button>
        </Card>
      </Paper>
    );
  }

  // Renderizado profesional para pasos de putaway (pieza y HU)
  if (flowKey && (flowKey.startsWith('putaway'))) {
    // Paso 1: Escaneo de área de staging
    if (stepIndex === 0 && step.type === 'scan' && step.field === 'staging-putaway') {
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <input
              ref={scanStagingInputRef}
              type="text"
              value={formData[step.field] || ''}
              onChange={e => setFormData({ ...formData, [step.field]: e.target.value })}
              onKeyDown={async (e) => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  const valor = e.target.value.trim().replace(/'/g, '-');
                  try {
                    const ubicacion = await getWmsUbicacionByCodigo(valor);
                    if (!ubicacion || !ubicacion.codigo) {
                      setError('Área de staging no encontrada');
                      setFormData({ ...formData, [step.field]: '' });
                      return;
                    }
                    setFormData({ ...formData, [step.field]: ubicacion.codigo });
                    setStagingArea(ubicacion.codigo);
                    setError('');
                    setLoadingInventarioStaging(true);
                    const inventario = await consultarInventarioAgrupadoConIds({ ubicacion: ubicacion.codigo });
                    setInventarioStaging(Array.isArray(inventario) ? inventario : []);
                    setLoadingInventarioStaging(false);
                    setTimeout(() => setStepIndex(stepIndex + 1), 500);
                  } catch {
                    setError('Área de staging no encontrada');
                    setFormData({ ...formData, [step.field]: '' });
                    setLoadingInventarioStaging(false);
                  }
                }
              }}
              placeholder={step.placeholder || 'Escanea o ingresa el área de staging'}
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanStagingInputRef.current && scanStagingInputRef.current.focus()}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">{step.placeholder || 'Escanea o ingresa el área de staging'}</Typography>
            </Box>
            {loadingInventarioStaging && <Typography color="primary" mb={2}>Cargando inventario de staging...</Typography>}
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            {inventarioStaging.length > 0 && (
              <Box width="100%" px={2} mb={2}>
                <Typography fontWeight={600} fontSize={16} color="#0057B8">Inventario disponible en staging:</Typography>
                <ul className="divide-y divide-gray-200">
                  {inventarioStaging.map((inv, idx) => (
                    <li key={idx} className="flex items-center justify-between py-1">
                      <span className="font-mono text-xs">{inv.sku || inv.hu_id}</span>
                      <span className="text-xs text-gray-500 ml-2">{inv.descripcion || inv.hu_id}</span>
                      <span className="text-xs font-bold ml-2">x{inv.cantidad}</span>
                    </li>
                  ))}
                </ul>
              </Box>
            )}
          </Card>
        </Paper>
      );
    }
    // Paso 2: Escaneo múltiple de SKU (putaway-pieza)
    if (stepIndex === 1 && step.type === 'scan' && step.field === 'scansku-putaway') {
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <input
              ref={scanSkuInputRef}
              type="text"
              inputMode="none"
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
              onKeyDown={async (e) => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  const valor = e.target.value.trim().replace(/'/g, '-');
                  const encontrado = inventarioStaging.find(inv => inv.sku === valor);
                  if (!encontrado) {
                    setError('No disponible en staging');
                    e.target.value = '';
                    return;
                  }
                  // Buscar datos de catálogo para descripción
                  let producto = null;
                  try {
                    producto = await getWmsProductoBySku(encontrado.sku);
                  } catch {}
                  const sku = encontrado.sku;
                  setDescripcionSku(prev => ({ ...prev, [sku]: producto?.descripcion || producto?.nombre || 'Sin descripción' }));
                  setProductosEscaneados(prev => {
                    const idx = prev.findIndex(p => p.sku === sku);
                    if (idx !== -1) {
                      // Validar que no se exceda la cantidad disponible
                      if (prev[idx].cantidad + 1 > encontrado.cantidad) {
                        setError('No puedes agregar más de la cantidad disponible');
                        return prev;
                      }
                      const updated = [...prev];
                      updated[idx].cantidad += 1;
                      return updated;
                    } else {
                      return [...prev, { sku, descripcion: producto?.descripcion || producto?.nombre || 'Sin descripción', cantidad: 1 }];
                    }
                  });
                  setError('');
                  e.target.value = '';
                }
              }}
              disabled={false}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">{step.placeholder || 'Escanea los SKUs para putaway (puedes repetir para sumar cantidades)'}</Typography>
            </Box>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            {/* Lista de productos escaneados */}
            <Box width="100%" px={2} mb={2}>
              {productosEscaneados.length > 0 && (
                <Box mb={1}>
                  <Typography fontWeight={600} fontSize={16} color="#0057B8">Productos escaneados:</Typography>
                  <ul className="divide-y divide-gray-200">
                    {productosEscaneados.map((p, idx) => (
                      <li key={idx} className="flex items-center justify-between py-1">
                        <span className="font-mono text-xs">{p.sku}</span>
                        <span className="text-xs text-gray-500 ml-2">{p.descripcion}</span>
                        <span className="text-xs font-bold ml-2">x{p.cantidad}</span>
                        <Button size="small" color="error" onClick={() => setProductosEscaneados(prev => prev.filter(x => x.sku !== p.sku))} sx={{ minWidth: 0, ml: 1, p: 0.5 }}>Eliminar</Button>
                      </li>
                    ))}
                  </ul>
                </Box>
              )}
            </Box>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2, width: '100%' }}
              onClick={() => {
                if (productosEscaneados.length === 0) {
                  setError('Escanea al menos un producto');
                  return;
                }
                setFormData({ ...formData, productos: productosEscaneados });
                setStepIndex(stepIndex + 1);
              }}
            >
              Siguiente
            </Button>
          </Card>
        </Paper>
      );
    }
    // Paso 2: Escaneo de HU (putaway-hu)
    if (stepIndex === 1 && step.type === 'scan' && step.field === 'scanhu-putaway') {
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <input
              ref={scanSkuInputRef}
              type="text"
              value={formData[step.field] || ''}
              onChange={e => setFormData({ ...formData, [step.field]: e.target.value })}
              onKeyDown={e => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  const valor = e.target.value.trim().replace(/'/g, '-');
                  let encontrado = null;
                  if (step.field === 'scansku-putaway') {
                    encontrado = inventarioStaging.find(inv => inv.sku === valor);
                  } else if (step.field === 'scanhu-putaway') {
                    encontrado = inventarioStaging.find(inv => String(inv.hu_id) === valor || String(inv.codigo) === valor);
                  }
                  if (!encontrado) {
                    setError('No disponible en staging');
                    setFormData({ ...formData, [step.field]: '' });
                    return;
                  }
                  setFormData({ ...formData, [step.field]: valor, inventarioSeleccionado: encontrado });
                  setError('');
                  setTimeout(() => setStepIndex(stepIndex + 1), 500);
                }
              }}
              placeholder={step.placeholder || (step.field === 'scansku-putaway' ? 'Escanea o ingresa el SKU' : 'Escanea o ingresa el código de HU')}
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">{step.placeholder || (step.field === 'scansku-putaway' ? 'Escanea o ingresa el SKU' : 'Escanea o ingresa el código de HU')}</Typography>
            </Box>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
          </Card>
        </Paper>
      );
    }
    // Paso 3: Escaneo de ubicación destino
    if (stepIndex === 2 && step.type === 'scan' && step.field === 'scanubicacion-putaway') {
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <input
              ref={scanSkuInputRef}
              type="text"
              value={formData[step.field] || ''}
              onChange={e => setFormData({ ...formData, [step.field]: e.target.value })}
              onKeyDown={async (e) => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  const valor = e.target.value.trim().replace(/'/g, '-');
                  try {
                    const ubicacion = await getWmsUbicacionByCodigo(valor);
                    if (!ubicacion || !ubicacion.codigo) {
                      setError('Ubicación destino no encontrada');
                      setFormData({ ...formData, [step.field]: '' });
                      return;
                    }
                    setFormData({ ...formData, [step.field]: ubicacion.codigo, ubicacionDestinoObj: ubicacion });
                    setError('');
                    setTimeout(() => setStepIndex(stepIndex + 1), 500);
                  } catch {
                    setError('Ubicación destino no encontrada');
                    setFormData({ ...formData, [step.field]: '' });
                  }
                }
              }}
              placeholder={step.placeholder || 'Escanea o ingresa la ubicación'}
              autoFocus
              style={{ opacity: 0, position: 'absolute', left: -9999 }}
              onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            />
            <Box mt={2} mb={2}>
              <Typography color="text.secondary" fontSize={16} textAlign="center">{step.placeholder || 'Escanea o ingresa la ubicación'}</Typography>
            </Box>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
          </Card>
        </Paper>
      );
    }
    // Paso 4: Confirmación y ejecución del movimiento
    if (stepIndex === 3 && step.type === 'confirm') {
      const inventario = formData.inventarioSeleccionado;
      const ubicacionDestino = formData.ubicacionDestinoObj;
      const handleConfirmarPutaway = async () => {
        try {
          const movimiento = {
            inventory_id: inventario?.ids ? inventario.ids[0] : undefined,
            producto_id: inventario?.producto_id,
            cantidad: inventario?.cantidad,
            origen_id: inventario?.ubicacion_id,
            destino_id: ubicacionDestino?.id,
            lote: inventario?.lote,
            estado_calidad: inventario?.estado_calidad,
            hu_id: inventario?.hu_id,
            cliente_id: inventario?.cliente_id,
            tipo: 'putaway',
            fecha: new Date().toISOString(),
            referencia: 'putaway',
            observaciones: 'Putaway automático',
            usuario_id: null
          };
          await registrarMovimientoInventario([movimiento]);
          setStepIndex(stepIndex + 1);
        } catch (err) {
          setError('Error al ejecutar el putaway: ' + (err?.message || ''));
        }
      };
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <Typography color="text.secondary" fontSize={16} textAlign="center" mb={2}>¿Deseas confirmar el putaway?</Typography>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            <Button
              variant="contained"
              color="success"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
              onClick={handleConfirmarPutaway}
            >
              Confirmar putaway
            </Button>
          </Card>
        </Paper>
      );
    }
    // Paso de confirmación profesional para putaway
    if (step.type === 'confirm-putaway' && flowKey.startsWith('putaway')) {
      const inventario = formData.inventarioSeleccionado;
      const ubicacionDestino = formData.ubicacionDestinoObj;
      const handleConfirmarPutaway = async () => {
        try {
          // Para putaway-pieza: iterar productos escaneados
          let movimientos = [];
          if (Array.isArray(formData.productos) && formData.productos.length > 0) {
            movimientos = formData.productos.map(prod => {
              const inv = inventarioStaging.find(i => i.sku === prod.sku);
              return {
                inventory_id: inv?.ids ? inv.ids[0] : undefined,
                producto_id: inv?.producto_id,
                cantidad: prod.cantidad,
                origen_id: inv?.ubicacion_id,
                destino_id: ubicacionDestino?.id,
                lote: inv?.lote,
                estado_calidad: inv?.estado_calidad,
                hu_id: inv?.hu_id,
                cliente_id: inv?.cliente_id,
                tipo: 'putaway',
                fecha: new Date().toISOString(),
                referencia: 'putaway',
                observaciones: 'Putaway automático',
                usuario_id: null
              };
            });
          } else if (inventario) {
            // Para putaway-hu (caso 1 a 1)
            movimientos = [{
              inventory_id: inventario?.ids ? inventario.ids[0] : undefined,
              producto_id: inventario?.producto_id,
              cantidad: inventario?.cantidad,
              origen_id: inventario?.ubicacion_id,
              destino_id: ubicacionDestino?.id,
              lote: inventario?.lote,
              estado_calidad: inventario?.estado_calidad,
              hu_id: inventario?.hu_id,
              cliente_id: inventario?.cliente_id,
              tipo: 'putaway',
              fecha: new Date().toISOString(),
              referencia: 'putaway',
              observaciones: 'Putaway automático',
              usuario_id: null
            }];
          }
          await registrarMovimientoInventario(movimientos);
          setStepIndex(stepIndex + 1);
        } catch (err) {
          setError('Error al ejecutar el putaway: ' + (err?.message || ''));
        }
      };
      return (
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>{step.label}</Typography>
            <Typography color="text.secondary" fontSize={16} textAlign="center" mb={2}>¿Deseas confirmar el putaway?</Typography>
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            <Button
              variant="contained"
              color="success"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
              onClick={handleConfirmarPutaway}
            >
              Confirmar putaway
            </Button>
          </Card>
        </Paper>
      );
    }
  }

  // PASOS ESPECÍFICOS DE PICKING
  // Paso 1: Escaneo de orden de salida
  if (step.type === 'scan-orden-salida') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanOrderInputRef}
            type="text"
            value={scanOrderInput}
            onChange={e => setScanOrderInput(e.target.value)}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanOrderInputRef.current && scanOrderInputRef.current.focus()}
            disabled={loadingOrder}
            onKeyDown={async (e) => {
              if (e.key === 'Enter' && scanOrderInput.trim()) {
                setLoadingOrder(true);
                setOrdenError('');
                setOrdenEntrada(null);
                try {
                  // Aquí deberías usar la API de salida, por ahora reutilizo getWmsOrdenByIdDocumento
                  const data = await getWmsOrdenByIdDocumento(scanOrderInput.trim().replace(/'/g, '-'));
                  if (data) {
                    if (data.estado === 'cerrada') {
                      setOrdenCerrada(true);
                      setOrdenError('La orden ya fue trabajada o está cerrada.');
                      setScanOrderInput('');
                      setLoadingOrder(false);
                      return;
                    }
                    setOrdenEntrada(data);
                    setScanOrderInput('');
                    setError('');
                    setStepIndex(stepIndex + 1);
                  } else {
                    setOrdenError('No se encontró la orden de salida con ese ID.');
                    setScanOrderInput('');
                  }
                } catch {
                  setOrdenError('Error al buscar la orden.');
                  setScanOrderInput('');
                } finally {
                  setLoadingOrder(false);
                }
              }
            }}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el número de orden de salida para iniciar el picking.'}
            </Typography>
          </Box>
          {ordenError && <Typography color="error" mb={2}>{ordenError}</Typography>}
          {loadingOrder && <Typography color="primary" mb={2}>Buscando orden...</Typography>}
          {ordenEntrada && (
            <Box mt={2}>
              <Typography color="success.main">Orden encontrada: {ordenEntrada.iddocumento}</Typography>
            </Box>
          )}
        </Card>
      </Paper>
    );
  }
  // Paso 2: Resumen de la orden de salida
  if (step.type === 'resumen-orden-salida' && !(flowKey === 'picking' && pickingActivo && pickingReady && productosPicking && productosPicking.length > 0 && pickingIndex < productosPicking.length)) {
    console.log('Return: Resumen de la orden de salida', { pickingActivo, pickingReady, productosPicking, pickingIndex });
    return (
      <>
        <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
          <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
            <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
              <HomeOutlinedIcon sx={{ fontSize: 28 }} />
            </Button>
          </Box>
          <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
            <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
              {step.label}
            </Typography>
            {ordenEntrada ? (
              <Box mb={2}>
                <Typography fontWeight={600} color="#0057B8">ID Documento:</Typography>
                <Typography fontFamily="monospace" mb={1}>{ordenEntrada.iddocumento || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Cliente:</Typography>
                <Typography mb={1}>{nombreCliente || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Almacén:</Typography>
                <Typography mb={1}>{nombreAlmacen || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Fecha:</Typography>
                <Typography mb={1}>{ordenEntrada.fecha || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Observaciones:</Typography>
                <Typography mb={1}>{ordenEntrada.observaciones || '-'}</Typography>
                <Typography fontWeight={600} color="#0057B8">Productos:</Typography>
                <Typography mb={1}>{ordenEntrada.productos?.length || 0}</Typography>
              </Box>
            ) : (
              <Typography color="error">No se ha encontrado la orden. Regresa y escanea nuevamente.</Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
              onClick={() => {
                if (flowKey === 'picking') {
                  setPickingIndexDebug(0);
                  setResumenPicking([]);
                  setUbicacionSugerida(null);
                  setCantidadPickeada('');
                  setUbicacionEscaneada('');
                  setPickingConfirmado(false);
                  if (ordenEntrada && Array.isArray(ordenEntrada.productos)) {
                    const nuevosProductos = ordenEntrada.productos.map(p => ({
                      ...p,
                      pickeado: false,
                      cantidad_pick: 0,
                      ubicacion_pick: ''
                    }));
                    setProductosPickingDebug(nuevosProductos);
                    if (nuevosProductos.length > 0) {
                      setPickingActivoDebug(true);
                      setPickingReadyDebug(true);
                    } else {
                      setPickingActivoDebug(false);
                      setPickingReadyDebug(false);
                    }
                  } else {
                    setPickingActivoDebug(false);
                    setPickingReadyDebug(false);
                  }
                } else {
                  setStepIndex(stepIndex + 1);
                }
              }}
              disabled={!ordenEntrada}
            >
              Iniciar Picking
            </Button>
          </Card>
        </Paper>
      </>
    );
  }
  // Paso 3: Escaneo de SKU o ubicación (scan-picking)
  if (step.type === 'scan-picking') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
            <span className="pi pi-barcode text-blue-500 text-4xl mr-2" style={{ fontSize: 48 }} />
          </Box>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            ref={scanSkuInputRef}
            type="text"
            value={scanInput}
            onChange={e => setScanInput(e.target.value)}
            inputMode="none"
            autoFocus
            style={{ opacity: 0, position: 'absolute', left: -9999 }}
            onBlur={e => scanSkuInputRef.current && scanSkuInputRef.current.focus()}
            onKeyDown={async (e) => {
              if (e.key === 'Enter' && scanInput.trim()) {
                setErrorScan('');
                const valor = scanInput.trim().replace(/'/g, '-');
                if (step.field === 'sku') {
                  // Buscar el producto en el catálogo por código_producto o código_barras
                  const productoCatalogo = catalogoProductos.find(
                    p => p.codigo_producto === valor || p.codigo_barras === valor
                  );
                  if (!productoCatalogo) {
                    setErrorScan('Producto no encontrado en catálogo');
                    setScanInput('');
                    return;
                  }
                  // Buscar en la orden de salida por producto_id
                  const lineaOrden = (ordenEntrada?.productos || []).find(
                    p => String(p.producto_id) === String(productoCatalogo.id)
                  );
                  if (!lineaOrden) {
                    setErrorScan('El producto no está en la orden de salida');
                    setScanInput('');
                    return;
                  }
                  setProductoSeleccionado({ ...lineaOrden, ...productoCatalogo });
                  setScanInput('');
                  setErrorScan('');
                  setStepIndex(stepIndex + 1);
                } else if (step.field === 'ubicacion') {
                  // Validar ubicación (puedes agregar lógica de validación avanzada aquí)
                  setFormData({ ...formData, [step.field]: valor });
                  setScanInput('');
                  setErrorScan('');
                  setStepIndex(stepIndex + 1);
                }
              }
            }}
            disabled={false}
          />
          <Box mt={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              {step.placeholder || 'Escanea o ingresa el código'}
            </Typography>
          </Box>
          {errorScan && <Typography color="error" mb={2}>{errorScan}</Typography>}
        </Card>
      </Paper>
    );
  }
  // Paso 4: Input de cantidad o lote/serie (input-picking)
  if (step.type === 'input-picking') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <input
            type={step.inputType === 'number' ? 'number' : 'text'}
            min={step.validation?.min || 1}
            value={formData[step.field] || ''}
            onChange={e => {
              let val = e.target.value;
              if (val === '' || (step.inputType === 'number' && isNaN(val))) {
                setFormData({ ...formData, [step.field]: '' });
                setError('');
                return;
              }
              if (step.inputType === 'number') {
                val = Number(val);
                if (val < (step.validation?.min || 1)) {
                  setError(`La cantidad debe ser al menos ${(step.validation?.min || 1)}`);
                } else {
                  setError('');
                }
              }
              setFormData({ ...formData, [step.field]: val });
            }}
            className="w-full border-2 border-orange-300 rounded-lg p-3 text-lg focus:outline-none focus:ring-2 focus:ring-orange-400 mb-4"
            placeholder={step.placeholder || ''}
            autoFocus
          />
          {error && <Typography color="error" mb={2}>{error}</Typography>}
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2 }}
            onClick={() => {
              if (!formData[step.field] || (step.inputType === 'number' && step.validation?.min && Number(formData[step.field]) < step.validation.min)) {
                setError('El campo es obligatorio y debe ser válido');
                return;
              }
              setError('');
              setStepIndex(stepIndex + 1);
            }}
            disabled={!formData[step.field] || !!error}
          >
            Siguiente
          </Button>
        </Card>
      </Paper>
    );
  }
  // Paso 5: Resumen de picking
  if (step.type === 'resumen-picking') {
    // Aquí puedes mostrar un resumen de los productos pickeados, pendientes, diferencias, etc.
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 480, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          {/* Aquí deberías mostrar el resumen real de picking */}
          <Box width="100%" px={2} mb={2}>
            <Typography color="text.secondary" fontSize={16} mb={2}>Resumen de productos pickeados (implementa la lógica real aquí)</Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
            onClick={() => setStepIndex(stepIndex + 1)}
          >
            Finalizar Picking
          </Button>
        </Card>
      </Paper>
    );
  }
  // Paso 6: Confirmación de picking
  if (step.type === 'confirm-picking') {
    return (
      <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
          <Button onClick={() => navigate('/wms/almacenaje')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
            <HomeOutlinedIcon sx={{ fontSize: 28 }} />
          </Button>
        </Box>
        <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 420, minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0 }}>
          <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
            {step.label}
          </Typography>
          <Typography color="text.secondary" fontSize={16} textAlign="center" mb={2}>
            ¿Deseas confirmar y finalizar el picking?
          </Typography>
          <Button
            variant="contained"
            color="success"
            sx={{ fontWeight: 700, fontSize: 16, py: 1.5, px: 4, mt: 2, mb: 2 }}
            onClick={() => {
              // Aquí deberías actualizar inventario y estatus de la orden
              setStepIndex(stepIndex + 1);
            }}
          >
            Confirmar y finalizar
          </Button>
        </Card>
      </Paper>
    );
  }

  // Fallback explícito al final del componente
  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'red'}}>
      <h2>ERROR: El flujo de picking no tiene un return válido. Revisa la lógica de avance y los returns condicionales.</h2>
      <pre>{JSON.stringify({ pickingActivo, pickingReady, productosPicking, pickingIndex, flowKey }, null, 2)}</pre>
    </div>
  );
}

// Extraigo PasoCompararInventario fuera de FlowRunner
function PasoCompararInventario({ ubicacion, productos, onContinue, navigate }) {
  const [inventario, setInventario] = React.useState([]);
  const [diferencias, setDiferencias] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    async function fetchInventario() {
      setLoading(true);
      setError('');
      try {
        const data = await consultarInventario({ ubicacion });
        setInventario(data || []);
      } catch (err) {
        setError('Error al consultar inventario.');
      } finally {
        setLoading(false);
      }
    }
    fetchInventario();
  }, [ubicacion]);

  React.useEffect(() => {
    if (!loading) {
      const inventarioMap = Object.fromEntries(inventario.map(i => [i.sku, i.cantidad]));
      const escaneadosMap = Object.fromEntries(productos.map(p => [p.sku, p.cantidad]));
      const comparacion = [];
      // Unir todos los SKUs únicos de inventario y escaneados
      const allSkus = Array.from(new Set([
        ...inventario.map(i => i.sku),
        ...productos.map(p => p.sku)
      ]));
      allSkus.forEach(sku => {
        const esperado = inventarioMap[sku] || 0;
        const encontrado = escaneadosMap[sku] || 0;
        comparacion.push({
          sku,
          encontrado,
          esperado,
          diferencia: encontrado !== esperado,
          inesperado: esperado === 0 && encontrado > 0
        });
      });
      setDiferencias(comparacion);
    }
  }, [inventario, productos, loading]);

  if (loading) return (
    <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#e3f0ff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
      <Typography color="#0057B8" fontWeight={700} fontSize={24}>Cargando inventario...</Typography>
    </Paper>
  );
  if (error) return (
    <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
      <Typography color="error" fontWeight={700} fontSize={24}>{error}</Typography>
    </Paper>
  );

  return (
    <Paper elevation={6} square sx={{ width: '100vw', height: '100vh', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#e3f0ff', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
      <Box sx={{ position: 'absolute', top: 16, left: 16, zIndex: 10 }}>
        <Button onClick={() => navigate('/wms/inventario')} variant="contained" color="primary" sx={{ minWidth: 0, p: 1, borderRadius: '50%', boxShadow: 2 }}>
          <HomeOutlinedIcon sx={{ fontSize: 28 }} />
        </Button>
      </Box>
      <Card sx={{ boxShadow: 0, borderRadius: 4, p: 0, width: '100%', maxWidth: 520, minHeight: 520, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, pt: 2 }}>
        <Box mt={2} mb={1} display="flex" alignItems="center" justifyContent="center">
          <span className="pi pi-exclamation-triangle text-yellow-500 text-4xl mr-2" style={{ fontSize: 48 }} />
        </Box>
        <Typography fontWeight={700} fontSize={22} color="#0057B8" textAlign="center" mb={2}>
          Diferencias encontradas
        </Typography>
        {diferencias.every(d => !d.diferencia) && (
          <Box mb={2}>
            <Typography color="success.main" fontWeight={700} fontSize={20} textAlign="center">
              ¡Sin diferencias! Todo coincide entre lo escaneado y el inventario.
            </Typography>
          </Box>
        )}
        <Box width="100%" px={2} mb={2}>
          <Box sx={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f0f6ff' }}>
                  <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>SKU</th>
                  <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>Encontrado</th>
                  <th style={{ padding: 8, fontWeight: 700, color: '#0057B8' }}>Esperado</th>
                  <th style={{ padding: 8 }}></th>
                </tr>
              </thead>
              <tbody>
                {diferencias.map((d) => (
                  <tr key={d.sku} style={{ background: d.diferencia ? (d.inesperado ? '#fffbe6' : '#fff') : '#e6ffe6' }}>
                    <td style={{ padding: 8, fontFamily: 'monospace', fontWeight: 600 }}>{d.sku}</td>
                    <td style={{ padding: 8, color: d.diferencia ? (d.encontrado > d.esperado ? '#16a34a' : d.encontrado < d.esperado ? '#dc2626' : '#0057B8') : '#16a34a', fontWeight: 700, fontSize: 18 }}>
                      {d.encontrado}
                    </td>
                    <td style={{ padding: 8, color: d.diferencia ? '#0057B8' : '#16a34a', fontWeight: 700, fontSize: 18 }}>{d.esperado}</td>
                    <td style={{ padding: 8 }}>
                      {d.inesperado && d.diferencia && (
                        <Typography color="warning.main" fontWeight={700}>Inesperado</Typography>
                      )}
                      {!d.diferencia && (
                        <Typography color="success.main" fontWeight={700}>OK</Typography>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
        <Button
          variant="contained"
          color="success"
          sx={{ fontWeight: 700, fontSize: 18, py: 2, px: 4, mt: 2, mb: 2, width: '100%' }}
          onClick={() => onContinue(diferencias)}
        >
          Continuar
        </Button>
      </Card>
    </Paper>
  );
}


export default FlowRunner;
